import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useRef } from "react";

function DataScienceCoursePune() {
  const [toggle, setTg] = useState();
  const [activeSection, setActiveSection] = useState("");
  const sectionRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const topOffset = sectionRef.current.getBoundingClientRect().top;
      setIsSticky(window.pageYOffset > topOffset);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const sections = document.querySelectorAll("section");

      sections.forEach((section) => {
        const sectionTop = section.offsetTop - 350; // adjust 50 to the height of your fixed header
        const sectionBottom = sectionTop + section.offsetHeight;

        if (
          currentScrollPos >= sectionTop &&
          currentScrollPos < sectionBottom
        ) {
          setActiveSection(section.id);
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    // Load YouTube Iframe Player API
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    var videoWrap = document.querySelector(".video-wrap");
    var video = document.querySelector(".video");
    var videoHeight = video.offsetHeight;
    var state;

    function getVideoID() {
      var videoIframe = document.querySelector("iframe");
      var videoURL = videoIframe.getAttribute("src");
      var id = videoURL.split("/")[4].split("?")[0];
      var playerDiv = document.createElement("div");
      playerDiv.setAttribute("id", "player");
      videoIframe.parentNode.insertBefore(playerDiv, videoIframe.nextSibling);
      videoIframe.parentNode.removeChild(videoIframe);
      return id;
    }
    window.onYouTubeIframeAPIReady = () => {
      var videoID = getVideoID();
      const player = new window.YT.Player("player", {
        width: "100%",
        height: "450",
        videoId: videoID,
        events: {
          // onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
        },
      });

      // function onPlayerReady(event) {
      //   event.target.playVideo();
      // }

      function onPlayerStateChange(event) {
        state = event.target.getPlayerState();
        if (state == 2) {
          video.classList.remove("stuck");
          video.classList.remove("stuck");
        }

        window.addEventListener("scroll", function () {
          var windowScrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
          var videoBottom = videoHeight + videoWrap.offsetTop;
          if (state == 1) {
            if (windowScrollTop > videoBottom) {
              videoWrap.style.height = videoHeight + "px";
              video.classList.add("stuck");
            } else {
              videoWrap.style.height = "auto";
              video.classList.remove("stuck");
            }
          }
        });
      }
    };
  }, []);

  return (
    <div>
      <title>Best Data Science Courses Online - Logicmojo</title>
      <meta
        name="description"
        content="Data Science course online with experts trainers with certification helps you master skills in data science, Machine Learning, data analytics etc. Become a certified Data Scientist."
      />
      <link
        rel="canonical"
        href="https://logicmojo.com/datascience-course/"
      />
      <meta property="og:type" content="article" />
      <meta
        property="og:title"
        content="Best Data Science Courses Online - Logicmojo"
      />
      <meta
        property="og:description"
        content="Data Science course online with experts trainers with certification helps you master skills in data science, Machine Learning, data analytics etc. Become a certified Data Scientist."
      />
      <meta
        property="og:url"
        content="https://logicmojo.com/datascience-course/"
      />
      <meta property="og:site_name" content="Logicmojo" />
      <meta
        property="article:modified_time"
        content="2023-03-17T11:45:44+00:00"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:image"
        content="https://logicmojo.com/assets/dist/new_pages/images/datas.png"
      />
      <meta name="twitter:label1" content="Est. reading time" />
      <meta name="twitter:data1" content="1 minute" />

      <div className="banner-ai">
        <div className="container position-relative">
          <div className="banner-ai-inner">
            <div className="banner-ai-links">
              <ul>
                <li>
                  <Link to="https://logicmojo.com">Home</Link>
                </li>
                <li>
                  <a href="">Data Science Course</a>
                </li>
              </ul>
            </div>
            <div className="bestsaller">
              <span>
                <i className="fa fa-star" aria-hidden="true"></i> Bestseller
              </span>
            </div>
            <div className="bestsaller">
              <div className="ratinglink">
                Review 4.8
                <div className="ratingstarfa">
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                  <i className="fa fa-star" aria-hidden="true"></i>
                </div>
                <a href="#ratingreviews">(8591 Ratings)</a>
              </div>
            </div>
            <div className="banner-ai-text">
              <h1>Data Science Course in Pune</h1>
              <p>
              Develop into a skilled Data Scientist by enrolling in our comprehensive Data Science courses 
              tailored for working professionals in Pune, India. Our courses in Pune location offer 
              the opportunity to learn from industry experts and gain hands-on experience in Data Science, 
              empowering you to advance your career in this rapidly growing field.
              </p>
            </div>
            <div className="banner-ai-btngrp">
              <a
                target="_default"
                href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
                className="counsbtn btnstyle002"
              >
                Apply For Live Classes
              </a>
            
            </div>
            <div className="banner-ai-experts">
              <p>Ranked #1 Data Science Training in Pune With Industry Experts From</p>
              <a href="">
                <img alt="" src="assets/images/gramener.png" />
              </a>
              <a href="">
                <img alt="" src="assets/images/actify.png" />
              </a>
              <a href="">
                <img src="assets/images/flipcart.png" alt="" />
              </a>
              <a href="">
                <img src="assets/images/walmart.png" alt="" />
              </a>
              <a href="">
                <img alt="" src="assets/images/zee.png" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="banner-aistrip">
        <div className="container">
          <ul>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon1.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <h5>120% Average Hike</h5>
                <p>in Job Switch</p>
              </div>
            </li>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon2.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <h5>8 Months</h5>
                <p>Weekend Live Classes</p>
              </div>
            </li>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon3.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <h5>Project Based Learning</h5>
                <p>Real Time Projects</p>
              </div>
            </li>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon4.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <h5>Job Assistance</h5>
                <p>100% Placements</p>
              </div>
            </li>
            <li>
              <span>
                <img src="assets/images/banner-aistrip-icon5.png" alt="" />
              </span>
              <div className="banner-aistrip-text">
                <h5>Starts at INR 5,160/month*</h5>
                <p>EMI Options Available</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      

      <div className="itfeaturevideorow">
        <div className="container">
          <h2>
            Data Science Courses to Become Expert <b>Data Scientist</b>
          </h2>
          <br />
          <br />
          {/* <div className="itfeaturevideo">
            <iframe
              loading="lazy"
              src="https://www.youtube.com/embed/MZ6eHbNnngk"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen=""
              width="100%"
              height="450"
              frameBorder="0"
            ></iframe>
          </div> */}

          <div className="video-wrap">
            <div className="video">
              <iframe
                loading="lazy"
                src="https://www.youtube.com/embed/aiqdypMW64I"
                // src="https://www.youtube.com/embed/MZ6eHbNnngk"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen=""
                width="40%"
                height="450"
                frameBorder="0"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <section id="careeropp" className="careeroppbg">
      <center><div style={{ paddingLeft: 10 + "px" }}>
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div></center>
          </section>

      <section
        className={isSticky ? "fixed-nav sec-navbar" : "sec-navbar"}
        ref={sectionRef}
      >
        <nav className="container d-flex justify-content-between align-items-center">
          <ul>

          <li className={activeSection === "projects" ? "active" : ""}>
              <a href="#projects">Projects</a>
            </li>
            <li className={activeSection === "careeropp" ? "active" : ""}>
              <a target="_default" href="https://drive.google.com/file/d/1W_wPuu7vn3RQB-XdtIPCdLGeKPybRElI/view">Course Brochure</a>
              </li>
            <li className={activeSection === "syllabus" ? "active" : ""}>
              <a href="#syllabus">Syllabus</a>
            </li>
            <li className={activeSection === "syllabus" ? "active" : ""}>
              <a href="#Fee">Fee</a>
            </li>
            <li className={activeSection === "careeropp" ? "active" : ""}>
              <a href="#careeropp">Career Opportunities</a>
            </li>
            <li className={activeSection === "getcertfied" ? "active" : ""}>
              <a href="#getcertfied">Certification</a>
            </li>
            <li className={activeSection === "faqs" ? "active" : ""}>
              <a href="#faqs">FAQs</a>
            </li>
            <li className={activeSection === "ratingreviews" ? "active" : ""}>
              <a href="#ratingreviews">Reviews</a>
            </li>
            <li className={activeSection === "specialisation" ? "active" : ""}>
              <a href="#specialisation">Specialisation</a>
            </li>
            
          </ul>
          <div style={{ paddingLeft: 10 + "px" }}>
          <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
              className="enroll-btn btn btn-danger"
            >
              <b>Apply Now</b>
            </a>
          </div>
        </nav>
      </section>

      <section id="careeropp" className="careeroppbg">
        <div className="container">
          <div className="careeroppbg-inner">
            <h2>
              What roles does a <b>Data Scientist</b> Play?
            </h2>
            <br />
            <br />

            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab01">
                  <span>
                    <img src="assets/images/opportunities-icon1.png" alt="" />
                  </span>
                  Machine Learning Engineer
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link active" data-toggle="tab" href="#tab02">
                  <span>
                    <img src="assets/images/opportunities-icon2.png" alt="" />
                  </span>
                  Data Scientist
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab03">
                  <span>
                    <img src="assets/images/opportunities-icon3.png" alt="" />
                  </span>
                  Software Engineer
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab04">
                  <span>
                    <img src="assets/images/opportunities-icon4.png" alt="" />
                  </span>
                  Data Analytics
                </a>
              </li>
            </ul>

            <div className="tab-content">
              <div id="tab01" className="tab-pane">
                <div className="careeroppbg-inner-text">
                  <p>
                  According to job market data, the demand for machine learning engineers has increased by 
                  over 344% since 2015. As machine learning technologies continue to evolve and become 
                  more sophisticated, the demand for skilled engineers who can design, develop, 
                  and implement machine learning systems will only continue to grow. This trend is also 
                  observed in Pune, India, where the demand for machine learning engineers has seen a significant 
                  rise. Pune, with its thriving technology ecosystem and numerous IT companies, is emerging as a 
                  hub for machine learning professionals. In industries such as healthcare, finance, and e-commerce, 
                  which are prominent in Pune, the application of machine learning is becoming increasingly prevalent. 
                  Machine learning is being utilized to develop predictive models, detect fraud, and personalize user experiences. 
                  As Pune becomes a key player in the field of machine learning engineer, there are ample opportunities for 
                  individuals to build their careers in this exciting and rapidly expanding domain.
                  </p>
                  <h3>Average Salaries</h3>
                  <h3>
                    Rs. 2400K - Rs. 6000K <span>Per annum</span>
                  </h3>
                  <h4>Hiring Compenies</h4>
                  <a href="">
                    <img src="assets/images/microsofticon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/walmarticon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/googleicon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/amazonicon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/flipcarticon.png" alt="" />
                  </a>
                </div>
              </div>
              <div id="tab02" className="tab-pane fade active show">
                <div className="careeroppbg-inner-text">
                  <p>
                  The demand for data scientists has been increasing rapidly in recent years, 
                  and this trend is also observed in Pune, India. According to job market data, 
                  the demand for data scientists in Pune has seen a significant rise, with an 
                  increase of over 650% since 2018. As businesses across industries recognise the value 
                  of data-driven insights, the need for skilled data scientists is expected to continue to 
                  grow in Pune. Data scientists are sought-after professionals who possess a diverse skill set, 
                  combining technical expertise, analytical capabilities, and effective communication skills. 
                  In Pune, data scientists are expected to leverage their skills and knowledge to derive actionable 
                  insights from data and drive informed business decisions. With Pune's vibrant technology landscape and 
                  its position as a prominent IT hub, there are ample opportunities for aspiring data scientists to contribute to the 
                  growth and success of organisations in the region.
                  </p>
                  <h3>Average Salaries</h3>
                  <h3>
                    Rs. 2000K - Rs. 8000K <span>Per annum</span>
                  </h3>
                  <h4>Hiring Compenies</h4>
                  <a href="">
                    <img src="assets/images/microsofticon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/walmarticon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/googleicon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/amazonicon.png" alt="" />
                  </a>
                  <a href="">
                    <img src="assets/images/flipcarticon.png" alt="" />
                  </a>
                </div>
              </div>
              <div id="tab03" className="tab-pane fade">
                <div className="careeroppbg-inner-text">
                  <p>
                    Software engineer also work as statistics, machine learning,
                    and data visualization in addition to programming skills.
                  </p>
                  <h3>Average Salaries</h3>
                  <h3>
                    Rs. 400K - Rs. 2000K <span>Per annum</span>
                  </h3>
                 
                </div>
              </div>
              <div id="tab04" className="tab-pane fade">
                <div className="careeroppbg-inner-text">
                  <p>
                  Data analytics professionals in Pune, India, are highly skilled in collecting, 
                  organizing, and analyzing data to extract meaningful insights and identify patterns and trends. 
                  They utilize a variety of tools and techniques, including statistical analysis, data visualization, 
                  and machine learning, to derive valuable insights from large and complex datasets. Pune's burgeoning 
                  technology sector and its prominence as an IT hub provide an ideal environment for data analytics 
                  professionals to thrive. The explosion of digital data in recent years has been a significant driver 
                  for the demand for data analytics professionals in Pune. As businesses increasingly digitize their 
                  operations, there is a growing need for professionals who can effectively analyze and interpret this 
                  wealth of data, enabling organizations to make informed decisions and gain a competitive edge. 
                  In Pune, the demand for data analytics professionals is on the rise, offering ample opportunities for 
                  individuals to contribute to the success of businesses across various industries in the region.
                  </p>
                  <h3>Average Salaries</h3>
                  <h3>
                    Rs. 400K - Rs. 2000K <span>Per annum</span>
                  </h3>
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="careeropp" className="careeroppbg">
      <center><div style={{ paddingLeft: 10 + "px" }}>
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div></center>
          </section>

      <section id="getcertfied" className="getcertfiedbgnew">
        <div className="container">
          <div className="getcertfiedbgnew-inner">
            <center>
              <h2>
                Data Science Course <b>Key Highlights</b>
              </h2>
            </center>
            <br />
            <br />
            <h6>
            Master the skills of Data Science and AI with hands-on experience through real-world projects in Pune, 
            and seamlessly transition into a role as a Data Scientist or AI-ML professional.
            </h6>
            <div className="row">
              <div className="col-md-4">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-laptop" aria-hidden="true"></i>
                  <h2>100% Live Online Classes</h2>
                  <p>
                    Faculty led Live Interactive online classes on weekend &amp;
                    Live doubt sessions on Weekdays
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-file-text-o" aria-hidden="true"></i>
                  <h2>Build Work Experience</h2>
                  <p>
                    Don't just Learn, Apply your learnings - work with companies
                    project.Real-world experience by working on live projects
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="getcertfiedbgnew-box">
                  <i className="fa fa-briefcase" aria-hidden="true"></i>
                  <h2>Land your Dream Job</h2>
                  <p>
                    Secure a guaranteed job referral to leading companies and
                    startups, and kickstart your career in data science, AI
                    &amp; Machine Learning.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="ourclientbg-new">
        <div className="container">
          <h3>Our Alumni Works at</h3>
          <div className="owl-carousel owl-theme">
            <div className="item">
              <img src="assets/images/microsofticon.png" alt="" />
              <img src="assets/images/walmarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/amazonicon.png" alt="" />
              <img src="assets/images/flipcarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/microsofticon.png" alt="" />
              <img src="assets/images/walmarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/amazonicon.png" alt="" />
              <img src="assets/images/flipcarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/microsofticon.png" alt="" />
              <img src="assets/images/walmarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
            <div className="item">
              <img src="assets/images/amazonicon.png" alt="" />
              <img src="assets/images/flipcarticon.png" alt="" />
              <img src="assets/images/googleicon.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <section id="careeropp" className="careeroppbg">
      <center><div style={{ paddingLeft: 10 + "px" }}>
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div></center>
          </section>

      <div className="whymakesnew">
        <div className="container">
          <h2>
            Data Science Course <b>Features</b>
          </h2>
          <br></br>
          <div className="row">
            <div className="col-md-4">
              <div className="whymakes-box">
                <img src="assets/images/whymake-icon1.png" alt="" />
                <h4>1-on-1 Dedication</h4>
                <p>
                  Experience personalized learning and growth with live
                  interactive sessions led by industry experts
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="whymakes-box">
                <img src="assets/images/whymake-icon2.png" alt="" />
                <h4> Practical Experience through Real-Time Projects</h4>
                <p>
                  Gain invaluable real-world experience by working on live
                  projects. Switch your domain to Data Science &amp; AI with
                  real time projects.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="whymakes-box">
                <img src="assets/images/whymake-icon3.png" alt="" />
                <h4>Life Time Access </h4>
                <p>
                  Life Time accessibility of the Content. Get Access of all
                  Recording of All Classes for Download in Slack Channel.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="whymakes-box">
                <img src="assets/images/studyassigment.png" alt="" />
                <h4>60+ Case Studies &amp; Assignments</h4>
                <p>
                  Work on 60+ Case studies ad assignments with 24/7 Assignments
                  suport.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="whymakes-box">
                <img src="assets/images/industries.png" alt="" />
                <h4>18+ Industry Relevant Projects</h4>
                <p>
                  Work on 60+ Case studies ad assignments with 24/7 Assignments
                  suport.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="whymakes-box">
                <img src="assets/images/whymake-icon3.png" alt="" />
                <h4>Tied-up with 150+ Companies</h4>
                <p>
                  Work on 60+ Case studies ad assignments with 24/7 Assignments
                  suport.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section id="careeropp" className="careeroppbg">
      <center><div style={{ paddingLeft: 10 + "px" }}>
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div></center>
          </section>

      <div className="specialisation-bg">
        <div className="container">
          <h2>
            Data Science Specialisation Program <b>in Pune</b>
          </h2>
          <br></br>
          <h5>
            Below topics and skills can you expect to acquire during an 8-month
            data science course
          </h5>

          <ul className="nav nav-tabs" role="tablist">
            <li className="nav-item">
              <a className="nav-link active" data-toggle="tab" href="#tab06">
                Python & Applied Statistics
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#tab07">
                Machine Learning
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#tab08">
                Deep Learning TensorFlow
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#tab09">
                Tableau & Power BI
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" data-toggle="tab" href="#tab010">
                NLP
              </a>
            </li>
          </ul>

          <div className="tab-content">
            <div id="tab06" className="tab-pane active">
              <div className="topic_covered">
                <h2>Topics Covered</h2>
                <div className="row">
                  <div className="col-md-6">
                    <div className="coveredrow">
                      <div className="coveredrow-left">
                        <span>1</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          Object-oriented programming <br />
                          &amp; in Python
                        </h3>
                        <ul>
                          <li>
                            OOP Terminology (classes, objects, inheritance,
                            polymorphism, encapsulation)
                          </li>
                          <li>
                            constructors and destructors, static methods,
                            overriding
                          </li>
                          <li>super() to call parent methods</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                      <div className="coveredrow-left">
                        <span>2</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Functional programming in Python</h3>
                        <li>
                          Built-in functions for iterables(map, filter, reduce,
                          etc.)
                        </li>
                        <li>Lambda functions,Closures, Function decorators</li>
                        <li>itertools, functools, operator module etc</li>
                        <li>Exceptional Handling and Regular Expression</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                      <div className="coveredrow-left">
                        <span>3</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          Python Data Structures <br />
                          &amp; Sets, Dictionaries, Namedtuples etc
                        </h3>
                        <li>
                          Basic Operations Indexing, Slicing, and Matrixes
                        </li>
                        <li>
                          List, Tuples, Dictionaries Python Lists, Tuples,
                          Dictionaries
                        </li>
                        <li>Exercises on List, Tuples And Dictionary</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                      <div className="coveredrow-left">
                        <span>4</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          NumPy, Pandas <br />
                          &amp; Matplotlib, Scikit-learn
                        </h3>
                        <li>
                          Introduction Numpy, Pandas, Matplotlib, Seaborn, Scipy
                        </li>
                        <li>Setting up the development environment</li>
                        <li>NumPy arrays and Data Types</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox5">
                      <div className="coveredrow-left">
                        <span>5</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          TensorFlow, Data Preprocessing <br />
                          &amp; Data visualization
                        </h3>
                        <li>
                          Installing TensorFlow and setting up the development
                          env
                        </li>
                        <li>Data cleaning and transformation</li>
                        <li>Creating subplots and multiple plots</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox6">
                      <div className="coveredrow-left">
                        <span>6</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3> Data Visualization using Matplotlib</h3>
                        <li>Matplotlib and setting up the development env</li>
                        <li>Advanced Plots with Matplotlib</li>
                        <li>
                          Advanced Visualizations: histograms, heatmaps and box
                        </li>
                        <li>Advanced customization with OOI</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox7">
                      <div className="coveredrow-left">
                        <span>7</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Data Analysis Using Pandas</h3>
                        <li>
                          Data structures in Pandas: Series and DataFrames
                        </li>
                        <li>Basic data exploration with Pandas</li>
                        <li>
                          Statistical Analysis &amp; Data visualization with
                          Pandas
                        </li>
                        <li>
                          Reshaping Data &amp; Hierarchical indexing in Pandas
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox8">
                      <div className="coveredrow-left">
                        <span>8</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Fundamentals of Math and Probability</h3>
                        <li>
                          Population, Sample, Mean, Population Distribution
                        </li>
                        <li>Sample Distribution,Mean, Median, Mode</li>
                        <li>Range, Measure of Dispersion, Variance</li>
                        <li>Probability Density function</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox9">
                      <div className="coveredrow-left">
                        <span>9</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          Standard, Normal Distribution, Gaussian Distribution
                        </h3>
                        <li>Standard Normal Distribution, Z Score</li>
                        <li>Cumulative Distribution function</li>
                        <li>Pearson Correlation Coefficient</li>
                        <li>Spearman Rank Coefficient, Hypothesis Testing</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox10">
                      <div className="coveredrow-left">
                        <span>10</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Q-Q plot, Bernoulli &amp; Binomial Distribution</h3>
                        <li>Q-Q plot, Skewness of Data</li>
                        <li>Discrete, Bernoulli & Continuous Distribution</li>
                        <li>Log normal, Poisson & Pox cox transformation</li>
                        <li>Application of Non Gaussian distribution</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox11">
                      <div className="coveredrow-left">
                        <span>11</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Poisson Distribution &amp; Advanced Statistics</h3>
                        <li>
                          Probability Mass Function and Cumulative Distribution
                        </li>
                        <li>
                          Poisson Approximation to the Binomial Distribution
                        </li>
                        <li>Hypothesis Testing and Statistical Inference</li>
                        <li>Case Study Based on Poisson Distribution</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox12">
                      <div className="coveredrow-left">
                        <span>12</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          Pearson Correlation Coefficient &amp; Covariance
                        </h3>
                        <li>
                          Linear regression,Hypothesis testing,Multiple
                          regression
                        </li>
                        <li>
                          Nonlinear regression,Time series analysis,Multivariate
                          analysis
                        </li>
                        <li>
                          Case study of Pearson Correlation Coefficient with
                          examples
                        </li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="tab07" className="tab-pane fade">
              <div className="topic_covered">
                <h2>Topics Covered</h2>
                <div className="row">
                  <div className="col-md-6">
                    <div className="coveredrow">
                      <div className="coveredrow-left">
                        <span>1</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Machine Learning Introduction</h3>
                        <li>
                          Overview of Machine Learning and its applications
                        </li>
                        <li>
                          Algorithm, Model, Predictor Variable,Response Variable
                        </li>
                        <li>Evaluation Metrics and Techniques</li>
                        <li>
                          Training - Test Split, Steps in Machine Learning
                        </li>
                        <li>
                          Types of Machine Learning (Supervised, Unsupervised,
                          Reinforcement)
                        </li>
                        <li>Data Preprocessing and Feature Engineering</li>
                        <li>
                          Performance Measures (Accuracy, Precision, Recall, F1
                          Score)
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                      <div className="coveredrow-left">
                        <span>2</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Regression Analysis and Supervised Learning</h3>
                        <li>
                          Overview Regression Analysis & Supervised Learning
                        </li>
                        <li>
                          Regression models: linear, polynomial, logistic, etc
                        </li>
                        <li>Training, Validation, & Test Sets</li>
                        <li>
                          Evaluation metrics: mean squared error (MSE),
                          R-squared etc
                        </li>
                        <li>
                          Linear Regression & Logistic: A Model-Based Approach
                        </li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>Stock Price Prediction using Linear regression</li>
                        <li>Spam mail detector for mailbox</li>
                        <li>
                          Predict car price using py-torch & SVC egression
                        </li>
                        <li>
                          Use logistics regression models to predict wine
                          quality
                        </li>
                        <li>
                          Use logistics regression to predict if loan approved
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                      <div className="coveredrow-left">
                        <span>3</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Supervised Learning - Classification </h3>
                        <li>Understanding Decision Trees and Naive Bayes</li>
                        <li>Linear classifiers</li>
                        <li>Decision Boundaries</li>
                        <li>K-Nearest Neighbours</li>
                        <li>Random Forest</li>
                        <li>Feature selection in Model building</li>
                        <li>Evaluating over fitting via training/test split</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Credit Card Fraud Detection using Classification
                          algorithms
                        </li>
                        <li>
                          Build model and evaluate water quality using random
                          forest
                        </li>
                        <li>
                          Purchase Prediction of Customer using Random Forest
                        </li>
                        <li>Confusion Matrix of Multi Class Classification</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                      <div className="coveredrow-left">
                        <span>4</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Unsupervised Learning - Clustering</h3>
                        <li>K-Means Clustering</li>
                        <li>Hierarchical Clustering</li>
                        <li>Mean-Shift Algorithm</li>
                        <li>Principal Component Analysis</li>
                        <li>Independent Component Analysis</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Music recommendation in Spotify using k-means
                          clustering
                        </li>
                        <li>
                          Topic Modelling for Twitter Customer Reviews
                          clustering
                        </li>
                        <li>
                          K-Means Clustering model to determine banknote is
                          authentic
                        </li>
                        <li>
                          Dimension reduction using PCA with clustering Model
                        </li>
                        <li>e-Commerce Products Dataset For Record Linkage</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox5">
                      <div className="coveredrow-left">
                        <span>5</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Unsupervised Learning - Association</h3>
                        <li>Association Rule Learning</li>
                        <li>FP-Growth Algorithm</li>
                        <li>
                          Anomaly Detection(Fraud Detection) with Clustering
                        </li>
                        <li>
                          Likeness of Item B Being Purchased after Item A
                          Prediction
                        </li>
                        <li>Frequent Itemsets Evaluation metrics</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Frequent itemset mining using Apriori or FP-growth
                          algorithm
                        </li>
                        <li>
                          Evaluate the performance of the recommendation System
                        </li>
                        <li>
                          K-Means Clustering model to determine banknote is
                          authentic
                        </li>
                        <li>
                          Dimension reduction using PCA with clustering Model
                        </li>
                        <li>e-Commerce Products Dataset For Record Linkage</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox6">
                      <div className="coveredrow-left">
                        <span>6</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Recommendation System </h3>
                        <li>Recommender Systems Overview</li>
                        <li>Collaborative Filtering</li>
                        <li>
                          Understanding Collaborative Filtering and Support
                          Vector
                        </li>
                        <li>
                          Normalizing Co-Occurrence Matrices and Leveraging
                        </li>
                        <li>The Matrix Completion Task</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Build Job recommendation using collaborative filtering
                        </li>
                        <li>
                          Build a travel recommendation system using datasets
                        </li>
                        <li>Build a Dashion Recommendation System</li>
                        <li>
                          Build a news article recommendation system using
                          datasets
                        </li>
                        <li>
                          Build music playlist recommendation using Support
                          Vector
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox7">
                      <div className="coveredrow-left">
                        <span>7</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Reinforced Learning</h3>
                        <li>Introduction To RL</li>
                        <li>Model-Based Reinforcement Learning</li>
                        <li>Open Al</li>
                        <li>Model Predictive Control (MPC)</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Autonomous Driving System can be trained using
                          reinforced
                        </li>
                        <li>Finance industry to develop trading algorithms</li>
                        <li>Build a Dashion Recommendation System</li>
                        <li>
                          Build a news article recommendation system using
                          datasets
                        </li>
                        <li>
                          Build music playlist recommendation using Support
                          Vector
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox8">
                      <div className="coveredrow-left">
                        <span>8</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3> Neural Networks</h3>
                        <li>Introduction to Neural Networks</li>
                        <li>Feedforward Neural Networks</li>
                        <li>Convolutional Neural Networks(CNNs)</li>
                        <li>Recurrent Neural Networks(RNNs)</li>
                        <li>Advanced Topics of Neural Networks</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Image Classification using Convolutional Neural
                          Networks
                        </li>
                        <li>
                          Sentiment Analysis using Recurrent Neural Networks
                        </li>
                        <li>Object Detection using Faster R-CNN</li>
                        <li>
                          Music Generation using Generative Adversarial Networks
                        </li>
                        <li>Game Playing using Deep Reinforcement Learning</li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="tab08" className="tab-pane fade">
              <div className="topic_covered">
                <h2>Topics Covered</h2>
                <div className="row">
                  <div className="col-md-6">
                    <div className="coveredrow">
                      <div className="coveredrow-left">
                        <span>1</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Deep Learning Overview </h3>
                        <li>What is Deep Learning</li>
                        <li>Machine Learning Vs Deep Learning</li>
                        <li>Tensorflow I Keras I Pytorch In details</li>
                        <li>Overview Caffe and Theano</li>
                        <li>Types of file formats in TensorFlow</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                      <div className="coveredrow-left">
                        <span>2</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>TensorFlow Classification Examples</h3>
                        <li>Introduction to TensorFlow</li>
                        <li>Installing TensorFlow</li>
                        <li>Simple Computation, Contents and Variables</li>
                        <li>TensorFlow Classification Examples</li>
                      </div>

                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          TensorFlow library to create a text-to-speech-to-text
                        </li>
                        <li>
                          TensorFlow Object Counting API function for tracking
                          vehicle
                        </li>
                        <li>
                          Identifies Different Musical Genres through Sounds
                        </li>
                        <li>
                          Identify customers purchase
                          history,gender,age,interest
                        </li>
                        <li>TensorFlow's Face Recognition Function</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                      <div className="coveredrow-left">
                        <span>3</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Deep Learning Algorithms </h3>
                        <li>Artificial Neural Networks(ANN)</li>
                        <li>Recurrent Neural Networks(RNN)</li>
                        <li>Convolutional Neural Networks(CNN)</li>
                        <li>Autoencoders and Boltzmann Machine</li>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>Speech Recognition with Deep Learning</li>
                        <li>
                          Build models with high accuracy Identify Human Face
                        </li>
                        <li>Music Genre Classification using DL</li>
                        <li>Image Classification with CIFAR Dataset</li>
                        <li>ChatBot Learning Human-to-Human Dialogue</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                      <div className="coveredrow-left">
                        <span>4</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Convolutional Neural Networks (CNN)</h3>
                        <li>Introduction to CNN</li>
                        <li>Convolutional layers</li>
                        <li>Pooling layers</li>
                        <li>Fully Connected Layers</li>
                        <li>Training CNNs</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox5">
                      <div className="coveredrow-left">
                        <span>5</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Recurrent Neural Networks (RNN)</h3>
                        <li>Introduction to RNN</li>
                        <li>Vanishing Gradient Problem</li>
                        <li>Long Short-Term Memory (LSTM) Networks</li>
                        <li>Gated Recurrent Units (GRU)</li>
                        <li>Applications of RNN</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox6">
                      <div className="coveredrow-left">
                        <span>6</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Neural Networks and Deep Learning</h3>
                        <li>
                          Introduction to artificial neural networks (ANN)
                        </li>
                        <li>Backpropagation algorithm</li>
                        <li>Activation functions</li>
                        <li>Loss functions</li>
                        <li>Optimization algorithms</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox7">
                      <div className="coveredrow-left">
                        <span>7</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Generative Adversarial Networks (GANs)</h3>
                        <li>Introduction to GANs</li>
                        <li>Generator and Discriminator Networks</li>
                        <li>Loss functions for GANs</li>
                        <li>Training GANs</li>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="coveredrow colorbox9">
                      <div className="coveredrow-left">
                        <span>9</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Transfer Learning</h3>
                        <li>Introduction to Transfer Learning</li>
                        <li>Pre-trained models</li>
                        <li>Fine-tuning</li>
                        <li>Applications of Transfer Learning</li>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="coveredrow colorbox8">
                      <div className="coveredrow-left">
                        <span>8</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Advanced Deep Learning Concepts</h3>
                        <li>Reinforcement Learning</li>
                        <li>Capsule Networks</li>
                        <li>Attention Mechanisms</li>
                        <li>Self-Organizing Maps (SOM)</li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="tab09" className="tab-pane fade">
              <div className="topic_covered">
                <h2>Topics Covered</h2>
                <div className="row">
                  <div className="col-md-6">
                    <div className="coveredrow">
                      <div className="coveredrow-left">
                        <span>1</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Introduction to Tableau</h3>
                        <li>
                          Installing Tableau and connecting to data sources
                        </li>
                        <li>Creating dashboard pages</li>
                        <li>How to create calculated columns</li>
                        <li>Data cleaning and reshaping</li>
                        <li>Creating a basic visualization</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                      <div className="coveredrow-left">
                        <span>2</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Visual Analytics</h3>
                        <li>Getting Started With Visual Analytics</li>
                        <li>Sorting and Grouping</li>
                        <li>Working with sets, set action</li>
                        <li>Filters: Ways to filter, Interactive Filters</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                      <div className="coveredrow-left">
                        <span>3</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Charts and Graphs</h3>
                        <li>Basic charts and Graph Types</li>
                        <li>Customizing Charts and Formatting</li>
                        <li>Interactive Features and actions</li>
                        <li>
                          Advanced chart types (e.g., maps, treemaps, scatter
                          plots)
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                      <div className="coveredrow-left">
                        <span>4</span>
                      </div>

                      <div className="coveredrow-right">
                        <h3>Tableau (Advance)</h3>
                        <li>Mapping</li>
                        <li>Coordinate points</li>
                        <li>Plotting Latitude and Longitude</li>
                        <li>Custom Geocoding</li>
                        <li>Polygon Maps</li>
                        <li>WMS and Background Image</li>
                      </div>

                      <div className="coveredrow-right">
                        <h3>Case Study</h3>
                        <li>Connecting data source and data cleansing </li>
                        <li>Working with various Charts </li>
                        <li>Deployment of Predictive model in visualization</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox5">
                      <div className="coveredrow-left">
                        <span>5</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Dashboard and Stories</h3>
                        <li>Working in Views with Dashboards and Stories</li>
                        <li>Working with Sheets Fitting Sheets</li>
                        <li>Legends and Quick Filters</li>
                        <li>Tiled and Floating Layouts</li>
                        <li>Floating Objects</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox6">
                      <div className="coveredrow-left">
                        <span>6</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Advanced Chart Types and Analytics</h3>
                        <li>
                          Creating Advanced Chart types (treemaps, heatmaps,
                          etc.)
                        </li>
                        <li>
                          Using statistical functions and analytics (trend
                          lines, forecasting)
                        </li>
                        <li>
                          Creating sets, groups, and bins for data analysis
                        </li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox7">
                      <div className="coveredrow-left">
                        <span>7</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Getting Started With Power BI</h3>
                        <li>Installing Power BI Desktop</li>
                        <li>Overview of the Workflow in Power BI Desktop</li>
                        <li>
                          Introducing the Different Views of the Data Mode
                        </li>
                        <li>Query Editor Interface</li>
                        <li>Working on Data Model</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox8">
                      <div className="coveredrow-left">
                        <span>8</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Programming with Power BI</h3>
                        <li>Working with Time Series</li>
                        <li>Understanding aggregation and granularity</li>
                        <li>Filters and Slicers in Power BI Maps</li>
                        <li>Scatterplots and BI Reports</li>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="coveredrow colorbox9">
                      <div className="coveredrow-left">
                        <span>9</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Connecting Dataset with Power BI</h3>
                        <li>Creating a Customer</li>
                        <li>Segmentation Dashboard</li>
                        <li>Analyzing the Customer</li>
                        <li>Segmentation Dashboard</li>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="coveredrow colorbox10">
                      <div className="coveredrow-left">
                        <span>10</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Advanced features</h3>
                        <li>
                          Creating calculated columns and measures with DAX
                        </li>
                        <li>Using custom visuals</li>
                        <li>
                          Building hierarchical visualizations with drill-downs
                        </li>
                        <li>Creating and using templates</li>
                        <li>
                          Publishing reports and dashboards to the Power BI
                          Service
                        </li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="tab010" className="tab-pane fade">
              <div className="topic_covered">
                <h2>Topics Covered</h2>
                <div className="row">
                  <div className="col-md-6">
                    <div className="coveredrow">
                      <div className="coveredrow-left">
                        <span>1</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Introduction to NLP</h3>
                        <li>Stop Words, Tokenization</li>
                        <li>Text Analytics Vs NLP</li>
                        <li>Bag of Words Model,Word Vectorizer</li>
                        <li>Introduction to Sequential data</li>
                        <li>Text Preprocessing using NLP</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox2">
                      <div className="coveredrow-left">
                        <span>2</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>Language Modeling</h3>
                        <li>N-gram models</li>
                        <li>Smoothing techniques</li>
                        <li>Language Model Evaluation</li>
                        <li>Working with maps and geographic data</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox3">
                      <div className="coveredrow-left">
                        <span>3</span>
                      </div>
                      <div className="coveredrow-right">
                        <h3>
                          Named Entity Recognition and Relation Extraction
                        </h3>
                        <li>Named entity Recognition</li>
                        <li>Relation Extraction</li>
                        <li>
                          Evaluation Metrics for NER and Relation Extraction
                        </li>
                        <li>Context-free Grammars using NLP</li>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="coveredrow colorbox4">
                      <div className="coveredrow-left">
                        <span>4</span>
                      </div>

                      <div className="coveredrow-right">
                        <h3>NLP Advanced</h3>
                        <li>RNNs and its Mechanisms</li>
                        <li>Vanishing & Exploding gradients in RNNs</li>
                        <li>NLP libraries: NLTK Text blog</li>
                        <li>LSTMs - Long Short-Term Memory</li>
                        <li>Neural Machine Translation</li>
                        <li>
                          Advanced Language Models: Transformers, BERT, XLNet
                        </li>
                      </div>

                      <div className="coveredrow-right">
                        <h3>Projects</h3>
                        <li>
                          Text summarization using Natural language processing
                        </li>
                        <li>
                          Deeper dive project of Automatic Speech Recognition
                        </li>
                        <li>
                          Newspaper Data Cleaning & Pre-processing using NLP
                        </li>
                        <li>Text Classification using scikit-learn and NLP</li>
                        <li>Hate Speech Detection Model</li>
                        <li>Next Word Prediction Model</li>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section id="careeropp" className="careeroppbg">
      <center><div style={{ paddingLeft: 10 + "px" }}>
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div></center>
          </section>
      <section id="projects" className="projectsnewbg">
        <div className="container">
          <center>
            <h2>Data Science Projects in the Course</h2>
          </center>
          <br></br>
          <h5>
            Projects will be a part of your Certification in Data Science
            Training to consolidate your learning. <br />
            It will ensure that you have real-world experience in Data Science
            Field.
          </h5>
          <div className="projectsnewbg-practice">
            <ul>
              <li>
                <img src="assets/images/practice-icon.png" alt="" />
                <h3>Practice 20+</h3>
                <p>Essential Tools</p>
              </li>
              <li>
                <img src="assets/images/designed-icon.png" alt="" />
                <h3 style={{ color: "#2aacf6" }}>Designed by</h3>
                <p>Industry Experts</p>
              </li>
              <li>
                <img src="assets/images/get-icon.png" alt="" />
                <h3 style={{ color: "#1fcd71" }}>Get Real-world</h3>
                <p>Experience</p>
              </li>
            </ul>
          </div>

          <div className="projectsnewbg-bottom">
            <ul className="nav nav-tabs" role="tablist">
              <li className="nav-item">
                <a className="nav-link active" data-toggle="tab" href="#tab012">
                  Beginner
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab013">
                  Intermediate
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="tab" href="#tab014">
                  Advance
                </a>
              </li>
            </ul>

            <div className="tab-content">
              <div id="tab012" className="tab-pane active">
                <div id="products" className="owl-carousel owl-theme">
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Face Detection</span>
                      </h3>
                      <p>
                        Face Detection is an initiative to create a computer
                        vision model that can automatically detect and locate
                        human faces within images or video frames.The goal of
                        this project is to enable machines to recognize and
                        analyze human faces in various contexts, such as
                        security, entertainment, or social media.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>AI Chatbot</span>
                      </h3>
                      <p>
                        Artificial intelligence-powered chatbot that can
                        communicate with humans in a natural language.project
                        involves designing, developing, and deploying a chatbot
                        that can perform specific tasks or answer questions for
                        users. The chatbot can be used for various purposes,
                        such as customer support, sales, marketing, or personal
                        assistance
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p>
                        Restaurant revenue prediction project is an initiative
                        to create a machine learning model that can forecast the
                        revenue of a restaurant based on various factors such as
                        customer footfall, menu items, prices, and marketing
                        promotions. The goal of this project is to help
                        restaurant owners make data-driven decisions to increase
                        their revenue and profitability.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Face Detection</span>
                      </h3>
                      <p>
                        climate change impacts project on the global food supply
                        is an initiative to investigate how climate change will
                        affect food production, distribution, and consumption
                        worldwide. The project aims to provide insights into how
                        these impacts may vary by region, crop type, and
                        socio-economic factors, and to identify potential
                        strategies for adaptation and mitigation.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>AI Chatbot</span>
                      </h3>
                      <p>
                        Credit card fraud detection using classification
                        algorithms is an initiative to create a machine learning
                        model that can automatically detect fraudulent
                        transactions in credit card transactions. The goal of
                        this project is to enable financial institutions to
                        detect and prevent fraud and protect their customers'
                        financial security.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p>
                        Water quality project using the random forest algorithm
                        in data science is an initiative to create a machine
                        learning model that can predict water quality parameters
                        such as pH, dissolved oxygen, biochemical oxygen demand
                        (BOD), and total suspended solids (TSS). Predict water
                        quality using datasets.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div id="tab013" className="tab-pane fade">
                <div id="products1" className="owl-carousel owl-theme">
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Face Detection</span>
                      </h3>
                      <p>
                        Purchase prediction of customer using random forest is a
                        data science project that aims to predict whether a
                        customer is likely to make a purchase based on their
                        historical purchase behavior and demographic data. The
                        goal of this project is to help businesses understand
                        their customers' purchasing patterns
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>AI Chatbot</span>
                      </h3>
                      <p>
                        Predicting house prices using regression is a data
                        science project that aims to create a machine learning
                        model that can predict the sale price of a house based
                        on various features such as the number of bedrooms,
                        bathrooms, square footage, location, and age of the
                        property
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>
                          Topic Modelling for Twitter Customer Reviews
                          clustering
                        </span>
                      </h3>
                      <p>
                        Topic modeling is a powerful technique in natural
                        language processing that can be used to extract and
                        identify themes or topics in a large corpus of text
                        data. In the context of Twitter customer reviews
                        clustering, topic modeling can be used to identify the
                        main themes or topics that customers are discussing in
                        their reviews
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Authentic vs. Fake Banknote Classification</span>
                      </h3>
                      <p>
                        Using supervised learning algorithms such as logistic
                        regression, decision trees, random forests, or support
                        vector machines (SVMs) used to authentic vs. fake
                        banknote classification.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p>
                        Principal Component Analysis (PCA) can help improve the
                        clustering performance by reducing the dimensionality of
                        the data. Dimension reduction using PCA with clustering
                        models is a powerful technique to reduce the
                        dimensionality of the data while improving the
                        clustering performance.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>E-Commerce Products Dataset</span>
                      </h3>
                      <p>
                        Record linkage is the process of linking records that
                        refer to the same entity or object across different data
                        sources. In the context of e-commerce products, record
                        linkage can be used to link product records from
                        different e-commerce platforms or retailers that refer
                        to the same product.
                      </p>
                    </div>
                  </div>

                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>
                          Anomaly Detection with clustering Data Science
                        </span>
                      </h3>
                      <p>
                        Anomaly detection, particularly for fraud detection, can
                        be achieved using clustering techniques in data science.
                        The idea is to use clustering to group data points
                        together and identify any outliers or anomalies that do
                        not belong to any cluster.
                      </p>
                    </div>
                  </div>

                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>
                          Likeness of Item B being purchased after item A
                          prediction
                        </span>
                      </h3>
                      <p>
                        Association rules mining is a technique used to find
                        patterns or relationships between items in a dataset. In
                        the context of e-commerce, association rules mining can
                        be used to find items that are frequently purchased
                        together, which can be used to make recommendations to
                        customers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div id="tab014" className="tab-pane fade">
                <div id="products2" className="owl-carousel owl-theme">
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>
                          Online Movie recommendation system to predict
                          preference
                        </span>
                      </h3>
                      <p>
                        Movie Recommendation system is a data science solution
                        that predicts the preferences of users for movies and
                        recommends relevant movies to them. The system uses
                        machine learning algorithms to analyze user data and
                        movie metadata to make predictions and recommendations.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/alI-chatbot.png" alt="" />
                      <h3>
                        <span>Online Books recommendation System</span>
                      </h3>
                      <p>
                        Collaborative filtering popular approach to
                        recommendation systems.It involves analyzing the
                        behavior of similar users to predict what a user might
                        like. For example, if User A and User B both read and
                        liked similar books, the system might recommend a new
                        book to User A based on the assumption that they will
                        also like it
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/restaurant-revenue.png" alt="" />
                      <h3>
                        <span>Restaurant Revenue Prediction</span>
                      </h3>
                      <p>
                        One popular architecture for speech recognition is the
                        recurrent neural network (RNN), which can model the
                        temporal dependencies in speech.Use the preprocessed
                        data to train your neural network.
                      </p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="products_slide">
                      <img src="assets/images/face-detection.png" alt="" />
                      <h3>
                        <span>Design chatGPT</span>
                      </h3>
                      <p>
                        Use ChatGPT deep learning techniques to generate
                        human-like responses to user inputs.ChatGPT uses a
                        variant of the transformer architecture called the
                        Generative Pre-trained Transformer (GPT). This
                        architecture allows the model to process sequences of
                        text and generate new text that is coherent and
                        grammatically correct
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section id="careeropp" className="careeroppbg">
      <center><div style={{ paddingLeft: 10 + "px" }}>
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div></center>
          </section>

      <section id="syllabus" className="syllabusnewbg">
        <div className="container">
          <div className="row">
            <div className="col-lg-7">
              <div className="syllabusheadings">
                <h1>
                  <span>Data Science Course Syllabus</span>
                  <a
                    target="_default"
                    href="https://drive.google.com/file/d/1W_wPuu7vn3RQB-XdtIPCdLGeKPybRElI/view"
                  >
                    <i className="fa fa-download mr-2" aria-hidden="true"></i>{" "}
                    Download brochure
                  </a>
                </h1>
                <p>
                  Logicmojo provides Live, Interactive Online Sessions guided by
                  Professionals working in top MNCs. All sessions are covered
                  practically with real-time industrial projects and case
                  studies.
                </p>
              </div>

              <div className="faqnew">
                <div className="accordion" id="accordionExample">
                  <div className="card">
                    <div className="card-header" id="heading00">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse00"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 1 Basic to
                          Advanced Python
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse00"
                      className="collapse"
                      aria-labelledby="heading00"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4>Chapter 1: Python deep-dive ( 3 hrs )</h4>
                          <ul>
                            <li>Working With Numbers, Booleans and Strings</li>
                            <li>
                              String types and formatting, String operations
                            </li>
                            <li>
                              List, Tuples, Dictionaries Python Lists, Tuples,
                              Dictionaries
                            </li>
                            <li>
                              Basic Operations Indexing, Slicing, and Matrixes
                            </li>
                            <li>Built-in Functions & Methods</li>
                            <li>Exercises on List,Tuples And Dictionary</li>
                            <li>Functions & Modules</li>
                            <li>Exceptional Handling and Regular Expression</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 2: Library of Python used for ML/AI
                          </h4>
                          <ul>
                            <li>Numpy, Pandas, Matplotlib, Seaborn, Scipy</li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 3: Data Analysis Using Numpy
                          </h4>
                          <ul>
                            <li>Introduction to Numpy</li>
                            <li>
                              Array Creation, Printing Arrays. Basic Operation
                            </li>
                            <li>
                              Indexing, Slicing and Iterating, Shape
                              Manipulation
                            </li>
                            <li>Vector stacking, Broadcasting with Numpy</li>
                            <li>Numpy for Statistical Operation</li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 3: Data Analysis Using Pandas
                          </h4>
                          <ul>
                            <li>Introduction to Pandas</li>
                            <li>Pandas Data Frames, Indexing Data Frames</li>
                            <li>Basic Operations With Data frame</li>
                            <li>Sub setting and filtering a data frame</li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 4: Data Visualization using Matplotlib
                          </h4>
                          <ul>
                            <li>How to use & configure Matplotlib</li>
                            <li>plot(), Controlling Line Properties</li>
                            <li>
                              Subplot with Functional Method, Multiple Plot
                            </li>
                            <li>Working with Multiple Figures</li>
                            <li>Histograms</li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 4: Data Visualization using Seaborn
                          </h4>
                          <ul>
                            <li>
                              Intro to Seaborn, Visualizing statistical
                              relationships
                            </li>
                            <li>Plotting with categorical data</li>
                            <li>Visualizing linear relationships</li>
                            <li>Seaborn Exercise</li>
                          </ul>
                          <h5>Project:</h5>
                          <p>1. Resume Screening project with Python Library</p>
                          <p>
                            2. Climate Change impacts on the Global Food Supply
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading001">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse001"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 2 -
                          Applied Statistics in Machine Learning
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse001"
                      className="collapse"
                      aria-labelledby="heading001"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4>
                            Chapter 1: Fundamentals of Math and Probability ( 3
                            hrs )
                          </h4>
                          <ul>
                            <li>Variables, Random Variables</li>
                            <li>
                              Population, Sample, Mean, Population Distribution
                            </li>
                            <li>Sample Distribution, Mean, Median, Mode</li>
                            <li>Range, Measure of Dispersion, Variance</li>
                            <li>Probability Density function</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 2: Statistics, Statistical Thinking
                          </h4>
                          <ul>
                            <li>Standard Normal Distribution, Z Score </li>
                            <li>Standard Deviation, Gaussian Distribution</li>
                            <li>Cumulative Distribution function</li>
                            <li>Hypothesis Testing & Plotting graph</li>
                            <li>Central limit theorem, Covariance</li>
                            <li>Pearson Correlation Coefficient</li>
                            <li>
                              Spearman Rank Coefficient, Hypothesis Testing
                            </li>
                          </ul>
                          <h4 className="mt-3">
                            Chapter 3: Advanced Statistics
                          </h4>
                          <ul>
                            <li>Q-Q plot,Skewness of Data </li>
                            <li>Discrete & continuous distribution</li>
                            <li>Bernoulli & binomial distribution</li>
                            <li>Log normal distribution </li>
                            <li>Pox cox transformation</li>
                            <li>Poisson distribution</li>
                            <li>Application of Non Gaussian distribution</li>
                          </ul>
                          <h5>Project:</h5>
                          <p>
                            1. Statical Analysis of Health Insurance Pricing
                            Forecast
                          </p>
                          <p>
                            2. Climate Change Impacts on the Global Food Supply
                          </p>
                          <p>
                            3. Statistical analysis of road accident in India
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading002">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse002"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 3 -
                          Machine Learning
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse002"
                      className="collapse"
                      aria-labelledby="heading002"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4>
                            Chapter 1: Machine Learning Introduction ( 3 hrs )
                          </h4>
                          <ul>
                            <li>Machine learning elements </li>
                            <li>
                              Algorithm, Model, Predictor Variable, Response
                              Variable
                            </li>
                          </ul>

                          <h4>
                            Chapter 2: Regression Supervised Learning( 3 hrs )
                          </h4>
                          <ul>
                            <li>Linear Regression</li>
                            <li>Support vector machine(SVC)</li>
                            <li>Ridge Regression</li>
                            <li>Logistics Regression</li>
                            <li>Lasso Regression</li>
                          </ul>
                          <h5>Project:</h5>
                          <p>
                            1. Stock Price Prediction using Linear regression
                          </p>
                          <p>2. Spam mail detector for mailbox</p>
                          <p>
                            3. Predict car price using py-torch & SVC egression
                          </p>
                          <p>
                            4. Use logistics regression models to predict wine
                            quality
                          </p>
                          <p>
                            5. Use logistics regression to predict if loan
                            approved or not
                          </p>

                          <h4 className="mt-3">
                            Chapter 3: Supervised Learning - Classification
                          </h4>
                          <ul>
                            <li>
                              Understanding Decision Trees and Naive Bayes
                            </li>
                            <li>Linear classifiers</li>
                            <li>Decision boundaries</li>
                            <li>K-Nearest Neighbours</li>
                            <li>Random forest</li>
                          </ul>
                          <h5>Project:</h5>
                          <p>
                            1. Credit Card Fraud Detection using Classification
                            algorithms
                          </p>
                          <p>
                            2. Build model and evaluate water quality using
                            random forest
                          </p>
                          <p>
                            3. Purchase prediction of customer using random
                            forest
                          </p>
                          <p>
                            4. Confusion Matrix of Multi Class Classification
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading003">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse003"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 3 -
                          Advance Machine Learning
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse003"
                      className="collapse"
                      aria-labelledby="heading003"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4>
                            Chapter 1: Unsupervised Learning Clustering ( 3 hrs
                            )
                          </h4>
                          <ul>
                            <li>K-Means Clustering</li>
                            <li>Hierarchical Clustering</li>
                            <li>Mean-shift algorithm</li>
                            <li>Principal Component Analysis</li>
                            <li>Independent Component Analysis</li>
                          </ul>
                          <h5>Project:</h5>
                          <p>
                            1. Music recommendation in Spotify using k-means
                            clustering
                          </p>
                          <p>
                            2. Topic Modelling for Twitter Customer Reviews
                            clustering
                          </p>
                          <p>
                            3. K-Means Clustering model to determine banknote is
                            authentic
                          </p>
                          <p>
                            3. Dimension reduction using PCA with clustering
                            Model
                          </p>
                          <p>
                            3. e-Commerce Products Dataset For Record Linkage
                          </p>

                          <h4 className="mt-3">
                            Chapter 2: Unsupervised Learning Association
                          </h4>
                          <ul>
                            <li>Introduction to unsupervised learning</li>
                            <li>
                              Clustering: Distance metrics, K-means,
                              hierarchical clustering
                            </li>
                            <li>
                              Types of Analysis - Descriptive, Predictive, and
                              Prescriptive
                            </li>
                            <li>
                              Bias Variance Tradeoff - Overfitting vs
                              Underfitting
                            </li>
                            <li>Clustering validation & Generative models</li>
                            <li>
                              Dimensionality Reduction: Principal Component
                              Analysis (PCA)
                            </li>
                          </ul>
                          <h5>Project:</h5>
                          <p>
                            1. Anomaly detection(fraud detection) with
                            clustering
                          </p>
                          <p>
                            2. Likeness of Item B being purchased after item A
                            prediction
                          </p>
                          <p>3. Fraud Detection in Financial Transactions</p>
                          <p>
                            4. Document Clustering in Natural Language
                            Processing
                          </p>

                          <h4 className="mt-3">
                            Chapter 3: Recommendation System
                          </h4>
                          <ul>
                            <li>Recommender systems overview</li>
                            <li>Collaborative filtering</li>
                            <li>
                              Understanding Collaborative Filtering and Support
                              Vector Machine
                            </li>
                            <li>
                              Normalizing co-occurrence matrices and leveraging
                              purchase histories
                            </li>
                            <li>The matrix completion task</li>
                            <li>Recommender systems ML block diagram</li>
                          </ul>
                          <h5>Project:</h5>
                          <p>
                            1. Online Movie recommendation system to predict
                            preference
                          </p>
                          <p>2. Online Books recommendation System</p>
                          <p>
                            3. e-commerce product recommendation like Amazon
                          </p>

                          <h4 className="mt-3">
                            Chapter 4: Reinforced Learning
                          </h4>
                          <ul>
                            <li>Introduction To RL</li>
                            <li>RL Techniques and Methods</li>
                            <li>
                              Value-Based Methods(Q-Learning,SARSA,Deep
                              Q-Networks)
                            </li>
                            <li>
                              Policy-Based Methods(Policy Gradient, REINFORCE,
                              Actor-Critic Methods)
                            </li>
                            <li>Exploration and Exploitation</li>
                          </ul>
                          <h5>Ensemble Techniques:</h5>
                          <p>Boosting | Gradient</p>
                          <p>Boosting | XGBoost</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading004">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse004"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 4 - Deep
                          Learning
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse004"
                      className="collapse"
                      aria-labelledby="heading004"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4>Chapter 1: Deep Learning Overview ( 3 hrs )</h4>
                          <ul>
                            <li>What is Deep Learning?</li>
                            <li>Machine Learning Vs Deep Learning</li>
                            <li>Tensorflow I Keras I Pytorch In details</li>
                            <li>Overview Caffe and Theano</li>
                            <li>Types of file formats in TensorFlow</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 2: TensorFlow Classification Examples
                          </h4>
                          <ul>
                            <li>Introduction to TensorFlow</li>
                            <li>Installing TensorFlow</li>
                            <li>Simple Computation, Contents and Variables</li>
                            <li>Types of file formats in TensorFlow</li>
                            <li>TensorFlow Classification Examples</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 3: Deep Learning Algorithms
                          </h4>
                          <ul>
                            <li>Artificial Neural Networks(ANN)</li>
                            <li>Recurrent Neural Networks(RNN)</li>
                            <li>Convolutional Neural Networks(CNN)</li>
                            <li>Autoencoders and Boltzmann Machine</li>
                            <li>Generative Adversarial Networks (GANs)</li>
                            <li>Restricted Boltzmann Machines (RBMs)</li>
                          </ul>

                          <h5>Project:</h5>
                          <p>1. Speech Recognition with Deep Learning</p>
                          <p>
                            2. Build models with high accuracy Identify Human
                            Face
                          </p>
                          <p>3. Music Genre Classification using DL</p>
                          <p>4. Image Classification with CIFAR Dataset</p>
                          <p>5. ChatBot Learning Human-to-Human Dialogue</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading005">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse005"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 5 -
                          Natural Language Processing
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse005"
                      className="collapse"
                      aria-labelledby="heading005"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4>Chapter 1: Introduction to NLP ( 3 hrs )</h4>
                          <ul>
                            <li>Introduction to NLP</li>
                            <li>Stop Words, Tokenization</li>
                            <li>Text Analytics Vs NLP</li>
                            <li>Bag of Words Model, Word Vectorizer</li>
                            <li>Types of file formats in TensorFlow</li>
                            <li>Introduction to Sequential data</li>
                          </ul>

                          <h4 className="mt-3">Chapter 2: NLP Advanced </h4>
                          <ul>
                            <li>RNNs and its Mechanisms</li>
                            <li>Vanishing & Exploding gradients in RNNs</li>
                            <li>NLP libraries: NLTK Text blog</li>
                            <li>LSTMs - Long short-term memory</li>
                            <li>Neural Machine Translation</li>
                            <li>
                              Advanced Language Models: Transformers, BERT,
                              XLNet
                            </li>
                          </ul>
                          <h5>Project:</h5>
                          <p>
                            1. Text summarization using Natural language
                            processing
                          </p>
                          <p>
                            2. Deeper dive project of Automatic Speech
                            Recognition
                          </p>
                          <p>
                            3. Newspaper Data Cleaning & Pre-processing using
                            NLP
                          </p>
                          <p>
                            4. Text Classification using scikit-learn and NLP
                          </p>
                          <p>5. Hate Speech Detection Model</p>
                          <p>6. Next Word Prediction Model</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading006">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse006"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 6- Tableau
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse006"
                      className="collapse"
                      aria-labelledby="heading006"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4>Chapter 1: Introduction to Tableau ( 3 hrs )</h4>
                          <ul>
                            <li>
                              Installing Tableau and connecting to data sources
                            </li>
                            <li>Creating dashboard pages</li>
                            <li>How to create calculated columns</li>
                            <li>Data cleaning and reshaping</li>
                            <li>Creating a basic visualization</li>
                          </ul>

                          <h4 className="mt-3">Chapter 2: Charts and Graphs</h4>
                          <ul>
                            <li>Basic charts and Graph Types</li>
                            <li>Customizing Charts and Formatting</li>
                            <li>Interactive Features and actions</li>
                            <li>
                              Advanced chart types (e.g., maps, treemaps,
                              scatter plots)
                            </li>
                          </ul>

                          <h4 className="mt-3">Chapter 3: Tableau (Advance)</h4>
                          <ul>
                            <li>Mapping</li>
                            <li>Coordinate points</li>
                            <li>Plotting Latitude and Longitude</li>
                            <li>Custom Geocoding</li>
                            <li>Polygon Maps</li>
                            <li>WMS and Background Image</li>
                          </ul>

                          <h5>Case Study:</h5>
                          <p>1. Connecting data source and data cleansing</p>
                          <p>2. Working with various Charts</p>
                          <p>
                            3. Deployment of Predictive model in visualization
                          </p>

                          <h4 className="mt-3">
                            Chapter 4: Dashboard and Stories
                          </h4>
                          <ul>
                            <li>
                              Working in Views with Dashboards and Stories
                            </li>
                            <li>Working with Sheets Fitting Sheets</li>
                            <li>Legends and Quick Filters</li>
                            <li>Tiled and Floating Layouts</li>
                            <li>Floating Objects</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 5: Advanced Chart Types and Analytics
                          </h4>
                          <ul>
                            <li>
                              Creating Advanced Chart types (treemaps, heatmaps)
                            </li>
                            <li>Working with Sheets Fitting Sheets</li>
                            <li>
                              Using statistical functions and analytics(trend
                              lines, forecasting)
                            </li>
                            <li>
                              Creating sets, groups, and bins for data analysis
                            </li>
                          </ul>
                          <h5>Projects:</h5>
                          <p>1. Patient Risk Healthcare Dashboard</p>
                          <p>2. Sales Forecast Analysis Dashboard</p>
                          <p>3. Product Availability Dashboard</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card">
                    <div className="card-header" id="heading007">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse007"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 7- Power
                          BI
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse007"
                      className="collapse"
                      aria-labelledby="heading007"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4>
                            Chapter 1: Getting Started With Power BI ( 3 hrs )
                          </h4>
                          <ul>
                            <li>Installing Power BI Desktop</li>
                            <li>
                              Overview of the Workflow in Power BI Desktop
                            </li>
                            <li>
                              Introducing the Different Views of the Data Mode
                            </li>
                            <li>Query Editor Interface</li>
                            <li>Working on Data Model</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 2: Programming with Power BI
                          </h4>
                          <ul>
                            <li>Working with Time Series</li>
                            <li>Understanding aggregation and granularity</li>
                            <li>Filters and Slicers in Power BI Maps</li>
                            <li>Scatterplots and BI Reports</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 3: Connecting Dataset with Power BI
                          </h4>
                          <ul>
                            <li>Creating a Customer</li>
                            <li>Segmentation Dashboard</li>
                            <li>Analyzing the Customer</li>
                            <li>Segmentation Dashboard</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 4: Advanced features Power BI
                          </h4>
                          <ul>
                            <li>
                              Creating calculated columns and measures with DAX
                            </li>
                            <li>Using custom visuals</li>
                            <li>
                              Building hierarchical visualizations with
                              drill-downs
                            </li>
                            <li>Creating and using templates</li>
                            <li>
                              Publishing reports and dashboards to the Power BI
                              Service
                            </li>
                          </ul>

                          <h5>Project:</h5>
                          <p>1. Financial Performance Analysis</p>
                          <p>
                            2. Anomaly Detection in Credit Card Transactions
                          </p>
                          <p>
                            3. AutoML Cashflow Optimization for Insurance
                            Company
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-header" id="heading008">
                      <h2 className="mb-0">
                        <button
                          type="button"
                          className="btn btn-link collapsed"
                          data-toggle="collapse"
                          data-target="#collapse008"
                          aria-expanded="false"
                        >
                          <i className="fa fa-angle-down"></i> Module 8 -
                          Computer Vision
                        </button>
                      </h2>
                    </div>

                    <div
                      id="collapse008"
                      className="collapse"
                      aria-labelledby="heading008"
                      data-parent="#accordionExample"
                    >
                      <div className="card-body">
                        <div className="moduleintro">
                          <h4>
                            Chapter 1: Introduction to Computer Vision ( 3 hrs )
                          </h4>
                          <ul>
                            <li>Human and Machine Vision</li>
                            <li>Applications of Computer Vision</li>
                          </ul>
                          <h5>Project:</h5>
                          <p>
                            1. Statical Analysis of Health Insurance Pricing
                            Forecast
                          </p>
                          <p>
                            2. Climate Change impacts on the Global Food Supply
                          </p>
                          <p>
                            3. Statistical analysis of road accident in India
                          </p>

                          <h4 className="mt-3">
                            Chapter 2: Image Formation and Representation
                          </h4>
                          <ul>
                            <li>Image Formation Model</li>
                            <li>Digital Images and Color Spaces</li>
                            <li>Image Enhancement and Filtering</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 3: Image Features and Feature Detection
                          </h4>
                          <ul>
                            <li>Edge Detection and Feature Detection</li>
                            <li>
                              Scale-Space Theory and Laplacian of Gaussian (LoG)
                            </li>
                            <li>
                              Scale-Space Theory and Laplacian of Gaussian (LoG)
                            </li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 4: Image Segmentation
                          </h4>
                          <ul>
                            <li>Thresholding and Region Growing</li>
                            <li>Edge-based and Boundary-based Segmentation</li>
                            <li>
                              Watershed Segmentation and Mean Shift Segmentation
                            </li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 5: Object Recognition and Classification
                          </h4>
                          <ul>
                            <li>Template Matching and Correlation</li>
                            <li>Object Recognition using Features</li>
                            <li>
                              Machine Learning Approaches to Object Recognition
                              and Classification
                            </li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 6: Deep Learning for Computer Vision
                          </h4>
                          <ul>
                            <li>Convolutional Neural Networks (CNNs)</li>
                            <li>Object Detection and Localization</li>
                            <li>Image Segmentation using CNNs</li>
                          </ul>

                          <h4 className="mt-3">
                            Chapter 7: Advanced Topics in Computer Vision
                          </h4>
                          <ul>
                            <li>Video Analysis and Tracking</li>
                            <li>Object Tracking and Localization</li>
                            <li>Medical Image Analysis and Applications</li>
                          </ul>

                          <h5>Project:</h5>
                          <p>1. AI based face detection system </p>
                          <p>2. Human emotion detection system </p>
                          <p>3. Handwritten Digit Recognition</p>
                          <p>
                            4. Computer vision system that can detect and locate
                            objects in an image
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="programmright">
                <h2>
                  Program <b>highlights</b>
                </h2>

                <div className="programlist">
                  <ul>
                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon01.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">110+ Hours Live sessions</div>
                      </div>
                    </li>

                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon02.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">3+ Projects</div>
                      </div>
                    </li>

                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon03.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">1:1 Doubt Session</div>
                      </div>
                    </li>

                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon04.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">1 Year Subscription </div>
                      </div>
                    </li>
                  </ul>

                  <ul>
                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon01.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">Life time accessibility</div>
                      </div>
                    </li>

                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon02.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">Job Assistance Program</div>
                      </div>
                    </li>

                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon03.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">Peer to peer Learning</div>
                      </div>
                    </li>

                    <li>
                      <div className="proginfoss">
                        <div className="priiconss">
                          <img
                            src="https://logicmojo.com/assets/dist/newindexpage/images/highicon04.jpg"
                            alt=""
                            border="0"
                          />
                        </div>

                        <div className="protxts">Mock Interview </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <p style={{ float: "left", width: "100%" }}>
                  <a target="_default"  href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06" className="applnowbtn mt-4">
                    Talk to our experts
                    <i
                      className="fa fa-angle-right arrowclass"
                      aria-hidden="true"
                    ></i>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="careeropp" className="careeroppbg">
      <center><div style={{ paddingLeft: 10 + "px" }}>
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div></center>
          </section>


      <div className="careerservices-new">
        <div className="container">
          <h2>Career Services By Logicmojo</h2>
          <br></br>
          <div className="careerservices-new-left">
            <img src="assets/images/career-services.png" alt="" />
          </div>
          <div className="careerservices-new-right">
            <div className="projectsnewbg-bottom">
              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#tab020"
                  >
                    Job Assistance
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-toggle="tab" href="#tab021">
                    Interview Preparation
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" data-toggle="tab" href="#tab022">
                    Profile Building
                  </a>
                </li>
              </ul>
              <div className="tab-content">
                <div id="tab020" className="tab-pane active">
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img
                        src="assets/images/placement-assistance.png"
                        alt=""
                      />
                    </div>
                    <div className="placement-assistance-right">
                      <h2>Job Assistance starts After Course Completion</h2>
                      <p>
                        Job referrals start after the completion of a course,
                        with career services professionals offering guidance and
                        support to students as they prepare to enter Data
                        Science & AI domain.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 100% of the course completion
                      </a>
                    </div>
                  </div>
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img src="assets/images/exclusive-access.png" alt="" />
                    </div>
                    <div className="placement-assistance-right">
                      <h2>Job Assistance Criteria</h2>
                      <p>
                        Job Assistance program for our candidates being regular
                        with classes. Get noticed & referred by our 150+ hiring
                        partners for the profile of Data Scientist, Machine
                        Learning Engineer, Data Analytics, MLOps as well as
                        Business Analytics.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 80% of the course completion
                      </a>
                    </div>
                  </div>
                </div>
                <div id="tab021" className="tab-pane">
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img src="assets/images/exclusive-access.png" alt="" />
                    </div>
                    <div className="placement-assistance-right">
                      <h2>
                        Learn Data Science, AI & ML with Case Studies & Projects
                      </h2>
                      <p>
                        Learn Full Stack AI & Data Scienece topics with 30+ real
                        projects with datasets. Designed & Implement Models,
                        Deploy in the Prod Environment. Make your profile storng
                        in Data Science & AI Field
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 100% of the course completion
                      </a>
                    </div>
                  </div>
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img
                        src="assets/images/placement-assistance.png"
                        alt=""
                      />
                    </div>
                    <div className="placement-assistance-right">
                      <h2>Mock Interviews & Mentorship 1 to 1 Sessions</h2>
                      <p>
                        Attend 1 to 1 Classes with the mentor during mentorship
                        program. Make your progress in the right direction under
                        guidance of mentor having 5+ years experience in DS, AI
                        & ML Domain. Check your progress with mock interviews 1
                        to 1 Online Session , experience the actual interview
                        environment.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 80% of the course completion
                      </a>
                    </div>
                  </div>
                </div>
                <div id="tab022" className="tab-pane">
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img
                        src="assets/images/placement-assistance.png"
                        alt=""
                      />
                    </div>
                    <div className="placement-assistance-right">
                      <h2>Resume Preparation </h2>
                      <p>
                        After completion of the course , we need to prepare
                        candidate resume before applying for IT Data Scientist
                        as well as Data analytics profile" rephrase. Attend 1 to
                        1 session with mentor for resume preparation discussion.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 100% of the course completion
                      </a>
                    </div>
                  </div>
                  <div className="placement-assistance">
                    <div className="placement-assistance-left">
                      <img src="assets/images/exclusive-access.png" alt="" />
                    </div>
                    <div className="placement-assistance-right">
                      <h2>Linkedin Profile Update</h2>
                      <p>
                        For every candidate profile will be updated in Linkedin
                        Portal. Linked is considered to be the major Hub for
                        hiring Data Scientist as well as ML engineer.
                      </p>
                      <a href="">
                        <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        After 80% of the course completion
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section id="careeropp" className="careeroppbg">
      <center><div style={{ paddingLeft: 10 + "px" }}>
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div></center>
          </section>

      <div className="network-reach-newbg">
        <div className="container">
          <h2>The Network Reach of Our Bay</h2>
          <br></br>
          <div className="row">
            <div className="col-lg-5">
              <div className="keyfeaturenew">
                <h2>Our Key Features</h2>
                <ul>
                  <li>
                    We help you build a strong profile and prepare for MNC
                    interviews.
                  </li>
                  <li>
                    Hassle-free and tailored training for MAANG company
                    interviews.
                  </li>
                  <li>
                    Even after a career break, securing a dream job is
                    achievable.
                  </li>
                  <li>
                    A successful career transition even with 0 coding
                    experience.
                  </li>
                </ul>
                {/* <a href="" className="downreportbtn">Download Placement Report <i className="fa fa-long-arrow-right" aria-hidden="true"></i></a> */}
              </div>
            </div>
            <div className="col-lg-7">
              <div className="keyfeaturenew-logo">
                <a href="">
                  <img src="assets/images/featurelogo1.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo2.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo3.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo4.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo5.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo1.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo2.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo3.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo4.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo5.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo1.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo2.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo3.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo4.png" alt="" />
                </a>
                <a href="">
                  <img src="assets/images/featurelogo5.png" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section id="careeropp" className="careeroppbg">
      <center><div style={{ paddingLeft: 10 + "px" }}>
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div></center>
          </section>

      <div className="certificate-companies">
        <div className="container">
          <div className="certificate-companies-img">
            <img src="assets/images/certificate-companies.png" alt="" />
          </div>
          <div className="certificate-companies-text">
            <h5>Data Science Certification</h5>
            <h2 style={{ fontSize: 25 }}>
              Get Ahead with Logicmojo's Master Certificate.
            </h2>
            <br></br>
            <ul>
              <li>
                <b>Get Ahead with Logicmojo's Master Certificate</b>
              </li>
              <p>
                Our class covers everything, and this Data Science certificate
                shows you've made great progress in learning the field.
              </p>
              <li>
                <b>Differentiate yourself with a Masters Certificate</b>
              </li>
              <p>
                The understanding and Data Science abilities you've developed
                through projects, simulations, and case studies will put you
                ahead of others.
              </p>
              <li>
                <b>Share your achievement</b>
              </li>
              <p>
                Share your Data Science certification on LinkedIn, Twitter, and
                Facebook, enhance your resume, or display it proudly - let your
                friends and colleagues know about your achievement
              </p>
            </ul>
            <a target="default" href="https://drive.google.com/file/d/1W_wPuu7vn3RQB-XdtIPCdLGeKPybRElI/view">
              Download Brochure
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="howtoapply-new">
        <div className="container">
          <h2 style={{ fontSize: 30 }}>
            How to Register For Logicmojo <b>Data Science Course</b>
          </h2>
          <div className="row">
            <div className="col-lg-8">
              <div className="howtoapply-new-left">
                <ul>
                  <li>
                    <h4>Step 1</h4>
                    <h3>Submit Application</h3>
                    <p>
                      Book calender call with our senior data scientist
                    </p>
                  </li>
                  <li>
                    <h4>Step 2</h4>
                    <h3>Application Review</h3>
                    <p>
                      Data scientist will review your profile & answer all your queries
                    </p>
                  </li>
                  <li>
                    <h4>Step 3</h4>
                    <h3>Admission</h3>
                    <p>
                      Candidate can apply for Online Live classes for 8 months
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="howtoapply-new-right">
                <h2>Apply For Live Course</h2>
                <div className="howtoapply-new-rightform">
                  <form>
                    <div className="row">

                      <div className="form-group col-lg-12">
                        <input
                          type="submit"
                          className="submitbtn"
                          value="Apply For Live Classes"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="programfeenew" id="Fee">
        <div className="container">
          <h2 style={{ fontSize: 30 }}>Data Science Course Fee</h2>
          <div className="programfeenew-inner">
            <div className="programfeenew-inner-left">
              <div className="programfeenew-inner-price">
                <p>Total Fee</p>
                <h2>₹ 65,000</h2>
              </div>
            </div>
            <div className="programfeenew-inner-right">
              <h5>No Cost EMI</h5>
              <div className="d-flex align-items-center justify-content-between">
                <h4>
                  <span>As low as</span> ₹ 5,160/month
                </h4>
                <a
                  target="_default"
                  href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
                >
                  Apply now
                </a>
              </div>
              <p>
                We have partnered with the following financing companies to
                provide competitive finance options at 0% interest rate with no
                hidden costs...
              </p>
              <ul>
                <li>
                  <img src="assets/images/feelogo1.png" alt="" />
                </li>
                <li>
                  <img src="assets/images/feelogo2.png" alt="" />
                </li>
                <li>
                  <img src="assets/images/feelogo3.png" alt="" />
                </li>
                <li>
                  <img src="assets/images/feelogo4.png" alt="" />
                </li>
                <li>
                  <img src="assets/images/feelogo5.png" alt="" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="eligibility-criteria-row">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="eligibility-criteria">
                <h2>Data Science Course Eligibility Criteria</h2>
                <ul className="eligibilitylist1">
                  <li>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon1.png"
                        alt=""
                      />
                    </span>
                    A bechelor's degree with an average of 50% or higher marks
                  </li>
                  <li>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon2.png"
                        alt=""
                      />
                    </span>
                    Basic understanding of programming concepts and mathematics
                  </li>
                  <li>
                    <span>
                      <img
                        src="assets/images/eligibilitylist1-icon3.png"
                        alt=""
                      />
                    </span>
                    2+ years of work experience preferred
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-md-6">
              <div className="eligibility-criteria">
                <h2>Who can apply for the Data Science course?</h2>
                <ul className="eligibilitylist2">
                  <li>Software engineers</li>
                  <li>IT Professionals</li>
                  <li>Data Professionals</li>
                  <li>Business Analysis</li>
                  <li>Product Managers</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section id="careeropp" className="careeroppbg">
      <center><div style={{ paddingLeft: 10 + "px" }}>
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div></center>
          </section>

      

      <section id="careeropp" className="careeroppbg">
      <center><div style={{ paddingLeft: 10 + "px" }}>
            <a target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
              className="btn btn-danger secondmenu_btn"
            >
              <b>Apply For Live Classes</b>
            </a>
          </div></center>
          </section>

      <section className="relatedcourses">
        <div className="container">
          <h2 style={{ fontSize: 25 }}>
            Our Data Science Courses Industry Mentors
          </h2>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="https://logicmojo.com/assets/dist/new_index_design/images/Mohammed-Shirhaan.png" />
                </div>

                <h3 className="name">Mohammed Shirhaan</h3>
                <p className="title">Lead Architect WalMartLabs</p>
                <p className="description">
                  Mohammed Shirhaan is currently working as a Lead Architect at WalMartLabs.
                  He has a vast experience of teaching Data Science.
                </p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/Mohammed-Shirhaan.jpg" />
                </div>

                <h3 className="name">Mohamed Shirhaan</h3>
                <p className="title">senior Data Science Mentor </p>
                <p className="description">
                  Shirhaan working as R & D Group of Informatica as senior data
                  Science Developer.
                </p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/priya1.png" />
                </div>
                <h3 className="name">Priya Singh</h3>
                <p className="title">Senior Mentor Data Scientist</p>
                <p className="description">
                  Priya work as a senior developer in Cisco as a Data Scientist.
                  Experienced in the field of Data Scientist.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

   

    

      <section className="relatedcourses">
        <div className="container">
          <h2 style={{ fontSize: 25 }}>Data Science Courses Faculty</h2>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/ravi-singh.jpg" />
                </div>

                <h3 className="name">Ravi Singh</h3>
                <p className="title">Experinced Senior Faculty Data Science</p>
                <p className="description">
                  Ravi has been part of multiple companies, gaining a wide array
                  of knowledge in data science. His background involves handling
                  various data kinds, applying diverse analysis methods.
                </p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/diwakar.png" />
                </div>

                <h3 className="name">Diwakar Choudhary</h3>
                <p className="title">Senior Faculty Member Data Science</p>
                <p className="description">
                  Diwakar has collaborated with numerous organizations, amassing
                  an extensive scope of expertise in data science. His
                  experience encompasses managing an assortment of data types
                  and employing a range of analytical approaches.
                </p>
              </div>
            </div>

            <div className="item">
              <div className="faculty-box">
                <div className="faculty-img">
                  <img src="assets/images/mac/Soumodeep-Mallick.jpg" />
                </div>
                <h3 className="name">Soumodeep Mallick</h3>
                <p className="title">Faculty Of Data Science</p>
                <p className="description">
                  Soumodeep has partnered with countless companies, building up
                  an impressive depth of proficiency in the data science field.
                  His experiences involve dealing with numerous data categories
                  and applying a wide spectrum of analytical techniques.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="datareviewsbg" id="ratingreviews">
        <div className="container">
          <h2>Learner Reviews for our Data Science Programs</h2>

          <div className="row">
            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/shivam.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Shivam Bajpai</h3>
                    <p>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p>
                I recently wrapped up a data science course in Pune, and I would 
                like to share my impressions and insights from the program. 
                Overall, I believe the course is a great asset for those interested 
                in entering the data science field or improving their current abilities. 
                The curriculum was skillfully crafted, covering all key aspects of data science, 
                including statistics, Python programming, machine learning, data analysis, and 
                large-scale data processing. The lessons were thoughtfully arranged, 
                starting from fundamental concepts and gradually progressing to more complex topics, 
                which made it easy to comprehend and follow the material. The course was held 
                in Pune, a vibrant city in India known for its rich educational ecosystem and thriving 
                IT industry. Pune's supportive environment and access to various tech communities further 
                enhanced the learning experience, allowing for networking opportunities and exposure to 
                real-world data science projects. I highly recommend this course for anyone in Pune looking to 
                kickstart their journey in data science.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/puneet.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Puneet</h3>
                    <p>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p>
                I recently completed an data science course in Pune and would like to share my feedback 
                and experiences about the program. The course proved to be an exceptional learning opportunity 
                for those looking to delve into data science or improve their existing skills in the field. 
                The course was meticulously structured, covering a wide range of crucial data science topics. 
                The instructors, based in Pune, were not only experts in their respective fields but also highly 
                accessible and supportive. They provided clear explanations and promptly addressed any questions 
                or concerns, making the learning experience even more valuable.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/diwakar.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Diwakar Choudhary</h3>
                    <p>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p>
                A key aspect of the data science course, held in Pune, was its emphasis on practical, hands-on learning experiences. Throughout the program, students were tasked with completing a variety of assignments, quizzes, and projects, encouraging them to apply their newfound knowledge to real-world scenarios. This approach not only deepened my understanding of the subject matter but also allowed me to build a compelling portfolio to showcase my skills to prospective employers. Pune's vibrant tech community and industry presence provided valuable networking opportunities and exposure to local data science projects, further enriching the learning experience. I highly recommend this course to anyone in Pune seeking to gain practical data science skills and advance their career in this rapidly growing field.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/afnaan.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Afnaan Rafique</h3>
                    <p>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p>
                The online format of the data science course, offered in Pune, provided the flexibility to learn at my own pace and according to my schedule. This was particularly beneficial for individuals, like myself, balancing work, family, and other commitments, making it an appealing option for learners with varying levels of availability. Despite not attending in-person classes, the course still fostered a sense of community through virtual discussions, collaborative projects, and online forums. Pune's strong IT infrastructure and digital connectivity further supported a seamless online learning experience. I appreciated the convenience and accessibility that the online format offered, allowing me to pursue my data science education from the comfort of my own home in Pune.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/piyush.jpg" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Piyush Mittal</h3>
                    <p>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p>
                A crucial element of the data science course, offered in Pune, focused on providing practical, experiential learning opportunities. During the program, students engaged in numerous tasks, tests, and projects that pushed them to utilize their acquired knowledge in real-life situations. This hands-on approach not only enriched my comprehension of the topics but also enabled me to create an impressive portfolio to demonstrate my abilities to potential employers. Pune's thriving tech ecosystem and collaborative environment further enhanced the practical learning experience, providing access to industry-relevant datasets and networking opportunities. I highly recommend this course to aspiring data scientists in Pune who are seeking to gain practical skills and build a strong foundation in the field.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="datareview">
                <div className="datareview-head">
                  <div>
                    <img src="assets/images/mac/priya.png" alt="" />
                  </div>
                  <div className="datareview-head-right">
                    <h3>Priya Singh</h3>
                    <p>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                      <i className="fa fa-star" aria-hidden="true"></i>
                    </p>
                  </div>
                </div>
                <p>
                  The structure of the data science course in Pune allowed for
                  the adaptability to study at a pace and schedule that suited
                  me. This proved to be especially advantageous for people,
                  including myself, who had to juggle work, family, and other
                  responsibilities, rendering it an attractive choice for
                  students with diverse time commitments.
                </p>
              </div>
            </div>
            <center>
              <a
                target="_default"
                href="https://www.google.com/search?q=logicmojo+review&oq=log&aqs=chrome.1.69i65j69i59j46i39i175i199j69i60l4j69i65.1921j0j7&sourceid=chrome&ie=UTF-8#lrd=0x3bae15239d632ad3:0x8248087353e6d723,1,,,,"
                className="btn btn-link collapsed"
              >
                View more reviews
              </a>
            </center>
          </div>
        </div>Related Data Science Courses 
      </section>

      <section id="relatedcourses" className="relatedcourses">
        <div className="container">
          <h2>Data Science Blogs</h2>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-science-interview-questions"
                >
                  <img src="assets/images/data-science-interview.jpeg" alt="" />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Data Science Interview Questions</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-science-introduction"
                >
                  <img
                    src="assets/images/mac/what-is-data-science-Intro.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Introduction : What is Data Science</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/machine-learning-interview-questions"
                >
                  <img
                    src="assets/images/mac/machine-learning-interview-question.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>Machine Learning Interview Questions</h3>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link
                  target="_default"
                  to="https://logicmojo.com/data-scientist-salary"
                >
                  <img
                    src="assets/images/mac/Data-Scientist-Salary.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3>What is Data Scientist Salary in India</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section id="relatedcourses" className="relatedcourses">
        <div className="container">
          <h2 style={{ fontSize: 25 }}>Related Data Science Courses in Pune</h2>
          <div className="owl-carousel owl-theme with-nav">
            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Advance-Data-Science-ML-Program">
                  <img
                    src="assets/images/resources/advance_data_Science_program.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Advance Data Science & AI Program in Pune
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>5096 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Advance-AI-ML-program">
                  <img
                    src="assets/images/resources/advance_ai_ml_program.jpg"
                    alt=""
                  />
                </Link>

                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>Advance AI & ML Program  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>8976 Learners</span>  
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/master-data-Science-ai-program">
                  <img
                    src="assets/images/resources/data_science_master_program.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Big Data & Data Science Program
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>10022 Learners</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Data-Science-For-Freshers">
                  <img
                    src="assets/images/resources/Data-Science-Fundamental.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                  Data Science Course For Freshers
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>986 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Data-Science-Course-For-Managers">
                  <img
                    src="assets/images/resources/data-Science-for-Managers.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    Data Science Course For Managers
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>1786 Learners</span>
                  </p>
                </div>
              </div>
            </div>

            <div className="item">
              <div className="relatedcoursebox">
                <Link to="/Practical-Decision-Making-in-Data-Science">
                  <img
                    src="assets/images/resources/Data-Science-Freshers.jpg"
                    alt=""
                  />
                </Link>
                <div className="relatedcoursebox-content">
                  <h3 style={{ fontSize: 15 }}>
                    AI Fundamental Course
                  </h3>
                  <p>
                    <span className="starlable">
                      4.8 <i className="fa fa-star" aria-hidden="true"></i>
                    </span>
                    <span>1586 Learners</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
     

      <section className="city-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 master-page-city-wrapper">
              <h4>
                <strong>
                Data Science Certification Training locations in Pune
                </strong>
              </h4>
              <div className="city-link-container">
                <Link
                  title="Ammrutha halli [560092]"
                  to="/Data-Science-Course-in-Pune"
                >
                  Bajirao Road [411002]
                </Link>
                <Link
                  title="Data Science Course in Bhilai"
                  to="/Data-Science-Course-in-Pune"
                >
                  Yerwada [411006]
                </Link>
                <Link
                  title="Data Science Course in Bhopal"
                  to="/Data-Science-Course-in-Pune"
                >
                  Kasba Peth [411011]
                </Link>
                <Link
                  title="Data Science Course in Bhubaneshwar"
                  to="/Data-Science-Course-in-Pune"
                >
                  Dhanori [411015]
                </Link>
                <Link
                  title="Data Science Course in Boston"
                  to="/Data-Science-Course-in-Pune"
                >
                  Pune City [411022]
                </Link>
                <Link
                  title="Data Science Course in Chandigarh"
                  to="/Data-Science-Course-in-Pune"
                >
                  Hadapsar S.O [411028]
                </Link>
                <Link
                  title="Data Science Course in Chennai"
                  to="/Data-Science-Course-in-Pune"
                >
                   Airport [411032]
                </Link>
                <Link
                  title="Data Science Course in Chicago"
                  to="/Data-Science-Course-in-Pune"
                >
                  Afmc [411040]
                </Link>
                <Link
                  title="Data Science Course in Cochin"
                  to="/Data-Science-Course-in-Pune"
                >
                  Karve Road [410038]
                </Link>
                <Link
                  title="Data Science Course in Coimbatore"
                  to="/Data-Science-Course-in-Pune"
                >
                  Ammunition Factory Khadki [411003]
                </Link>
                <Link
                  title="Data Science Course in Dallas"
                  to="/Data-Science-Course-in-Pune"
                >
                  Aundh [411007]
                </Link>
                <Link
                  title="Data Science Course in Dehradun"
                  to="/Data-Science-Course-in-Pune"
                >
                  Dapodi [411012]
                </Link>
                <Link
                  title="Data Science Course in Delhi"
                  to="/Data-Science-Course-in-Pune"
                >
                  Gokhalenagar [411016]
                </Link>
                <Link
                  title="Data Science Course in Dubai"
                  to="/Data-Science-Course-in-Pune"
                >
                  Kudje [411023]
                </Link>
                <Link
                  title="Data Science Course in Durban"
                  to="/Data-Science-Course-in-Pune"
                >
                  Kothrud [411029]
                </Link>
                <Link
                  title="Data Science Course in Faridabad"
                  to="/Data-Science-Course-in-Pune"
                >
                  Mundhva [411036]
                </Link>
                <Link
                  title="Data Science Course in Ghaziabad"
                  to="/Data-Science-Course-in-Pune"
                >
                   Tingre Nagar [411000]
                </Link>
                <Link
                  title="Data Science Course in Guntur"
                  to="/Data-Science-Course-in-Pune"
                >
                  A.R. Shala [411004]
                </Link>
                <Link
                  title="Data Science Course in Gurgaon"
                  to="/Data-Science-Course-in-Pune"
                >
                  Baner Road [411004]
                </Link>
                <Link
                  title="Data Science Course in Guwahati"
                  to="/Data-Science-Course-in-Pune"
                >
                  Magarpatta City [411013]
                </Link>
                <Link
                  title="Data Science Course in HongKong"
                  to="/Data-Science-Course-in-Pune"
                >
                  Botanical Garden [411020]
                </Link>
                <Link
                  title="Data Science Course in Hyderabad"
                  to="/Data-Science-Course-in-Pune"
                >
                  Khadakwasla [411024]
                </Link>
                <Link
                  title="Data Science Course in Jaipur"
                  to="/Data-Science-Course-in-Pune"
                >
                  Lokmanyanagar [411030]
                </Link>
                <Link
                  title="Data Science Course in Johannesburg"
                  to="/Data-Science-Course-in-Pune"
                >
                   Bibvewadi [411037]
                </Link>
                <Link
                  title="Data Science Course in Los Kanpur"
                  to="/Data-Science-Course-in-Pune"
                >
                  Bhavani Peth [411042]
                </Link>
                <Link
                  title="Data Science Course in Khammam"
                  to="/Data-Science-Course-in-Pune"
                >
                  Dhayari [411041]
                </Link>
                <Link
                  title="Data Science Course in Kolkata"
                  to="/Data-Science-Course-in-Pune"
                >
                  Dhankawadi [411043]
                </Link>
                <Link
                  title="Data Science Course in LosAngeles"
                  to="/Data-Science-Course-in-Pune"
                >
                  C D A O [411001]
                </Link>
                <Link
                  title="Data Science Course in Lucknow"
                  to="/Data-Science-Course-in-Pune"
                >
                  Shivajinagar [411005]
                </Link>
                <Link
                  title="Data Science Course in Madurai"
                  to="/Data-Science-Course-in-Pune"
                >
                  Parvati [411009]
                </Link>
                <Link
                  title="Data Science Course in Miami"
                  to="/Data-Science-Course-in-Pune"
                >
                  9 Drd [411014]
                </Link>
                <Link
                  title="Data Science Course in Mumbai"
                  to="/Data-Science-Course-in-Pune"
                >
                  Armament [411021]
                </Link>
                <Link
                  title="Data Science Course in Mysore"
                  to="/Data-Science-Course-in-Pune"
                >
                  Donje [411025]
                </Link>
                <Link
                  title="Data Science Course in Nagpur"
                  to="/Data-Science-Course-in-Pune"
                >
                  Bopkhel [411031]
                </Link>
                <Link
                  title="Data Science Course in Noida"
                  to="/Data-Science-Course-in-Pune"
                >
                  Bhusari Colony [411038]
                </Link>
                <Link
                  title="Data Science Course in Patna"
                  to="/Data-Science-Course-in-Pune"
                >
                  Haveli [411045]
                </Link>
                <Link
                  title="Data Science Course in Pondicherry"
                  to="/Data-Science-Course-in-Pune"
                >
                  Jambhulwadi [411046]
                </Link>
                <Link
                  title="Data Science Course in Ranchi"
                  to="/Data-Science-Course-in-Pune"
                >
                  Lohogaon [411047]
                </Link>
                <Link
                  title="Data Science Course in Seattle"
                  to="/Data-Science-Course-in-Pune"
                >
                  Khondhwa [411048]
                </Link>
                <Link
                  title="Data Science Course in Shimoga"
                  to="/Data-Science-Course-in-Pune"
                >
                  Anandnagar [411051]
                </Link>
                <Link
                  title="Data Science Course in Surat"
                  to="/Data-Science-Course-in-Pune"
                >
                  Navsahyadri [411052]
                </Link>
                <Link
                  title="Data Science Course in Thane"
                  to="/Data-Science-Course-in-Pune"
                >
                  Chatursringi [411053]
                </Link>
                <Link
                  title="Data Science Course in Thiruvananthapuram"
                  to="/Data-Science-Course-in-Pune"
                >
                  Gokhalenagar [411055]
                </Link>
                <Link
                  title="Data Science Course in Tiruchchirappalli"
                  to="/Data-Science-Course-in-Pune"
                >
                  Warje [411058]
                </Link>
                <Link
                  title="Data Science Course in Tirupati"
                  to="/Data-Science-Course-in-Pune"
                >
                  Mohamadwadi Kadvasti [411060]
                </Link>
                <Link
                  title="Data Science Course in Toronto"
                  to="/Data-Science-Course-in-Pune"
                >
                  Janaki Nagar [411066]
                </Link>
                <Link
                  title="Data Science Course in Trichur"
                  to="/Data-Science-Course-in-Pune"
                >
                  Aundh [411067]
                </Link>
                <Link
                  title="Data Science Course in Vadodara"
                  to="/Data-Science-Course-in-Pune"
                >
                  Pimpri Chinchwad [411078]
                </Link>
                <Link
                  title="Data Science Course in Visakhapatnam"
                  to="/Data-Science-Course-in-Pune"
                >
                  Nanded [411230]
                </Link>
                <Link
                  title="Data Science Course in Warangal"
                  to="/Data-Science-Course-in-Pune"
                >
                  Gondhale Nagar [412029]
                </Link>
                <Link
                  title="Data Science Course in Washington"
                  to="/Data-Science-Course-in-Pune"
                >
                  Sathe Nagar [412047]
                </Link>
                <Link
                  title="Data Science Course in Mountain View"
                  to="/Data-Science-Course-in-Pune"
                >
                  Alandi Devachi [412105]
                </Link>
                <Link
                  title="Data Science Course in Ashburn"
                  to="/Data-Science-Course-in-Pune"
                >
                  Ambarvet [412115]
                </Link>
                <Link
                  title="Data Science Course in Charlotte"
                  to="/Data-Science-Course-in-Pune"
                >
                  Ashtapur [412207]
                </Link>
                <Link
                  title="Data Science Course in Austin"
                  to="/Data-Science-Course-in-Pune"
                >
                  Manjari Farm [412307]
                </Link>
                <Link
                  title="Data Science Course in San Diego"
                  to="/Data-Science-Course-in-Pune"
                >
                  Phursungi [412308]
                </Link>
                <Link
                  title="Data Science Course in Irving"
                  to="/Data-Science-Course-in-Pune"
                >
                  Viman Nagar 411014
                </Link>
                <Link
                  title="Data Science Course in Columbus"
                  to="/Data-Science-Course-in-Pune"
                >
                  Shaniwar Peth [413337]
                </Link>
                
              </div>
            </div>
          </div>
        </div>
      </section>
      


      <section className="city-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 master-page-city-wrapper">
              <h4>
                <strong>
                Locations Offered in Pune
                </strong>
              </h4>
              <div className="city-link-container">
                <Link
                  title="Ammrutha halli [560092]"
                  to="/Data-Science-Course-in-Pune"
                >
                  Data Science Course viman nagar
                </Link>
                <Link
                  title="Data Science Course in Bhilai"
                  to="/Data-Science-Course-in-Pune"
                >
                  Data Science Training in kalyan nagar
                </Link>
                <Link
                  title="Data Science Course in Bhopal"
                  to="/Data-Science-Course-in-Pune"
                >
                  Data Science Training in magarpetta
                </Link>
                <Link
                  title="Data Science Course in Bhubaneshwar"
                  to="/Data-Science-Course-in-Pune"
                >
                  Data Science Training in pimpri chinchwad
                </Link>
                <Link
                  title="Data Science Course in Boston"
                  to="/Data-Science-Course-in-Pune"
                >
                  Data Science Classes in yerwada
                </Link>
                <Link
                  title="Data Science Course in Chandigarh"
                  to="/Data-Science-Course-in-Pune"
                >
                  Data Science Classes in kharadi
                </Link>
                <Link
                  title="Data Science Course in Chennai"
                  to="/Data-Science-Course-in-Pune"
                >
                   Data Science Classes in vishrantwadi
                </Link>
                <Link
                  title="Data Science Course in Chicago"
                  to="/Data-Science-Course-in-Pune"
                >
                  Data Science Classes in deccan
                </Link>
                <Link
                  title="Data Science Course in Cochin"
                  to="/Data-Science-Course-in-Pune"
                >
                  Data Science Course in Katraj
                </Link>
                <Link
                  title="Data Science Course in Coimbatore"
                  to="/Data-Science-Course-in-Pune"
                >
                  Data Science Training in warje
                </Link>
                <Link
                  title="Data Science Course in Dallas"
                  to="/Data-Science-Course-in-Pune"
                >
                  Data Science Certification Training in bavdhan
                </Link>
                <Link
                  title="Data Science Course in Dehradun"
                  to="/Data-Science-Course-in-Pune"
                >
                  Data Science Certification in boat club road
                </Link>
                <Link
                  title="Data Science Course in Delhi"
                  to="/Data-Science-Course-in-Pune"
                >
                  Data Science Certification in model colony
                </Link>
                <Link
                  title="Data Science Course in Dubai"
                  to="/Data-Science-Course-in-Pune"
                >
                  Best Data Science Training in pune
                </Link>
                <Link
                  title="Data Science Course in Durban"
                  to="/Data-Science-Course-in-Pune"
                >
                  Best Data Science Course in pune
                </Link>
                
                
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="city-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 master-page-city-wrapper">
              <h4>
                <strong>
                  Find Data Science Course Training in Other Regions
                </strong>
              </h4>
              <div className="city-link-container">
                <Link
                  title="Data Science Course in Ahmedabad"
                  to="/Data-Science-Course-Ahmedabad"
                >
                  Ahmedabad
                </Link>
                <Link
                  title="Data Science Course in Bhilai"
                  to="/Data-Science-Course-Bhilai"
                >
                  Bhilai
                </Link>
                <Link
                  title="Data Science Course in Bhopal"
                  to="/Data-Science-Course-Bhopal"
                >
                  Bhopal
                </Link>
                <Link
                  title="Data Science Course in Bhubaneshwar"
                  to="/Data-Science-Course-Bhubaneshwar"
                >
                  Bhubaneshwar
                </Link>
                <Link
                  title="Data Science Course in Boston"
                  to="/Data-Science-Course-Boston"
                >
                  Boston
                </Link>
                <Link
                  title="Data Science Course in Chandigarh"
                  to="/Data-Science-Course-Chandigarh"
                >
                  Chandigarh
                </Link>
                <Link
                  title="Data Science Course in Chennai"
                  to="/Data-Science-Course-Chennai"
                >
                  Chennai
                </Link>
                <Link
                  title="Data Science Course in Chicago"
                  to="/Data-Science-Course-Chicago"
                >
                  Chicago
                </Link>
                <Link
                  title="Data Science Course in Cochin"
                  to="/Data-Science-Course-Cochin"
                >
                  Cochin
                </Link>
                <Link
                  title="Data Science Course in Coimbatore"
                  to="/Data-Science-Course-Coimbatore"
                >
                  Coimbatore
                </Link>
                <Link
                  title="Data Science Course in Dallas"
                  to="/Data-Science-Course-Dallas"
                >
                  Dallas
                </Link>
                <Link
                  title="Data Science Course in Dehradun"
                  to="/Data-Science-Course-Dehradun"
                >
                  Dehradun
                </Link>
                <Link
                  title="Data Science Course in Delhi"
                  to="/Data-Science-Course-Delhi"
                >
                  Delhi
                </Link>
                <Link
                  title="Data Science Course in Dubai"
                  to="/Data-Science-Course-Dubai"
                >
                  Dubai
                </Link>
                <Link
                  title="Data Science Course in Durban"
                  to="/Data-Science-Course-Durban"
                >
                  Durban
                </Link>
                <Link
                  title="Data Science Course in Faridabad"
                  to="/Data-Science-Course-Faridabad"
                >
                  Faridabad
                </Link>
                <Link
                  title="Data Science Course in Ghaziabad"
                  to="/Data-Science-Course-Ghaziabad"
                >
                  Ghaziabad
                </Link>
                <Link
                  title="Data Science Course in Guntur"
                  to="/Data-Science-Course-Guntur"
                >
                  Guntur
                </Link>
                <Link
                  title="Data Science Course in Gurgaon"
                  to="/Data-Science-Course-Gurgaon"
                >
                  Gurgaon
                </Link>
                <Link
                  title="Data Science Course in Guwahati"
                  to="/Data-Science-Course-Guwahati"
                >
                  Guwahati
                </Link>
                <Link
                  title="Data Science Course in HongKong"
                  to="/Data-Science-Course-HongKong"
                >
                  HongKong
                </Link>
                <Link
                  title="Data Science Course in Hyderabad"
                  to="/Data-Science-Course-Hyderabad"
                >
                  Hyderabad
                </Link>
                <Link
                  title="Data Science Course in Jaipur"
                  to="/Data-Science-Course-Jaipur"
                >
                  Jaipur
                </Link>
                <Link
                  title="Data Science Course in Johannesburg"
                  to="/Data-Science-Course-Johannesburg"
                >
                  Johannesburg
                </Link>
                <Link
                  title="Data Science Course in Los Kanpur"
                  to="/Data-Science-Course-Kanpur"
                >
                  Kanpur
                </Link>
                <Link
                  title="Data Science Course in Khammam"
                  to="/Data-Science-Course-Khammam"
                >
                  Khammam
                </Link>
                <Link
                  title="Data Science Course in Kolkata"
                  to="/Data-Science-Course-Kolkata"
                >
                  Kolkata
                </Link>
                <Link
                  title="Data Science Course in LosAngeles"
                  to="/Data-Science-Course-LosAngeles"
                >
                  LosAngeles
                </Link>
                <Link
                  title="Data Science Course in Lucknow"
                  to="/Data-Science-Course-Lucknow"
                >
                  Lucknow
                </Link>
                <Link
                  title="Data Science Course in Madurai"
                  to="/Data-Science-Course-Madurai"
                >
                  Madurai
                </Link>
                <Link
                  title="Data Science Course in Miami"
                  to="/Data-Science-Course-Miami"
                >
                  Miami
                </Link>
                <Link
                  title="Data Science Course in Mumbai"
                  to="/Data-Science-Course-Mumbai"
                >
                  Mumbai
                </Link>
                <Link
                  title="Data Science Course in Mysore"
                  to="/Data-Science-Course-Mysore"
                >
                  Mysore
                </Link>
                <Link
                  title="Data Science Course in Nagpur"
                  to="/Data-Science-Course-Nagpur"
                >
                  Nagpur
                </Link>
                <Link
                  title="Data Science Course in Noida"
                  to="/Data-Science-Course-Noida"
                >
                  Noida
                </Link>
                <Link
                  title="Data Science Course in Patna"
                  to="/Data-Science-Course-Patna"
                >
                  Patna
                </Link>
                <Link
                  title="Data Science Course in Pondicherry"
                  to="/Data-Science-Course-Pondicherry"
                >
                  Pondicherry
                </Link>
                <Link
                  title="Data Science Course in Ranchi"
                  to="/Data-Science-Course-Ranchi"
                >
                  Ranchi
                </Link>
                <Link
                  title="Data Science Course in Seattle"
                  to="/Data-Science-Course-Seattle"
                >
                  Seattle
                </Link>
                <Link
                  title="Data Science Course in Shimoga"
                  to="/Data-Science-Course-Shimoga"
                >
                  Shimoga
                </Link>
                <Link
                  title="Data Science Course in Surat"
                  to="/Data-Science-Course-Surat"
                >
                  Surat
                </Link>
                <Link
                  title="Data Science Course in Thane"
                  to="/Data-Science-Course-Thane"
                >
                  Thane
                </Link>
                <Link
                  title="Data Science Course in Thiruvananthapuram"
                  to="/Data-Science-Course-Thiruvananthapuram"
                >
                  Thiruvananthapuram
                </Link>
                <Link
                  title="Data Science Course in Tiruchchirappalli"
                  to="/Data-Science-Course-Tiruchchirappalli"
                >
                  Tiruchchirappalli
                </Link>
                <Link
                  title="Data Science Course in Tirupati"
                  to="/Data-Science-Course-Tirupati"
                >
                  Tirupati
                </Link>
                <Link
                  title="Data Science Course in Toronto"
                  to="/Data-Science-Course-Toronto"
                >
                  Toronto
                </Link>
                <Link
                  title="Data Science Course in Trichur"
                  to="/Data-Science-Course-Trichur"
                >
                  Trichur
                </Link>
                <Link
                  title="Data Science Course in Vadodara"
                  to="/Data-Science-Course-Vadodara"
                >
                  Vadodara
                </Link>
                <Link
                  title="Data Science Course in Visakhapatnam"
                  to="/Data-Science-Course-Visakhapatnam"
                >
                  Visakhapatnam
                </Link>
                <Link
                  title="Data Science Course in Warangal"
                  to="/Data-Science-Course-Warangal"
                >
                  Warangal
                </Link>
                <Link
                  title="Data Science Course in Washington"
                  to="/Data-Science-Course-Washington"
                >
                  Washington
                </Link>
                <Link
                  title="Data Science Course in Mountain View"
                  to="/Data-Science-Course-MountainView"
                >
                  Mountain View
                </Link>
                <Link
                  title="Data Science Course in Ashburn"
                  to="/Data-Science-Course-Ashburn"
                >
                  Ashburn
                </Link>
                <Link
                  title="Data Science Course in Charlotte"
                  to="/Data-Science-Course-Charlotte"
                >
                  Charlotte
                </Link>
                <Link
                  title="Data Science Course in Austin"
                  to="/Data-Science-Course-Austin"
                >
                  Austin
                </Link>
                <Link
                  title="Data Science Course in San Diego"
                  to="/Data-Science-Course-SanDiego"
                >
                  San Diego
                </Link>
                <Link
                  title="Data Science Course in Irving"
                  to="/Data-Science-Course-Irving"
                >
                  Irving
                </Link>
                <Link
                  title="Data Science Course in Columbus"
                  to="/Data-Science-Course-Columbus"
                >
                  Columbus
                </Link>
                <Link
                  title="Data Science Course in Sunnyvale"
                  to="/Data-Science-Course-Sunnyvale"
                >
                  Sunnyvale
                </Link>
                <Link
                  title="Data Science Course in Fremont"
                  to="/Data-Science-Course-Fremont"
                >
                  Fremont
                </Link>
                <Link
                  title="Data Science Course in Denver"
                  to="/Data-Science-Course-Denver"
                >
                  Denver
                </Link>
                <Link
                  title="Data Science Course in Philadelphia"
                  to="/Data-Science-Course-Philadelphia"
                >
                  Philadelphia
                </Link>
                <Link
                  title="Data Science Course in Vijayawada"
                  to="/Data-Science-Course-Vijayawada"
                >
                  Vijayawada
                </Link>
                <Link
                  title="Data Science Course in Ireland"
                  to="/Data-Science-Course-Ireland"
                >
                  Ireland
                </Link>

                <Link
                  title="Data Science Course in Jamshedpur"
                  to="/Data-Science-Course-Jamshedpur"
                >
                  Jamshedpur
                </Link>
                <Link
                  title="Data Science Course in Kerala"
                  to="/Data-Science-Course-Kerala"
                >
                  Kerala
                </Link>
                <Link
                  title="Data Science Course in TamilNadu"
                  to="/Data-Science-Course-TamilNadu"
                >
                  TamilNadu
                </Link>

                <Link
                  title="Data Science Course in AbuDhabi"
                  to="/Data-Science-Course-AbuDhabi"
                >
                  AbuDhabi
                </Link>
                <Link
                  title="Data Science Course in Ludhiana"
                  to="/Data-Science-Course-Ludhiana"
                >
                  Ludhiana
                </Link>
                <Link
                  title="Data Science Course in Ernakulam"
                  to="/Data-Science-Course-Ernakulam"
                >
                  Ernakulam
                </Link>
                <Link
                  title="Data Science Course in Kottayam"
                  to="/Data-Science-Course-Kottayam"
                >
                  Kottayam
                </Link>
                <Link
                  title="Data Science Course in Khammam"
                  to="/Data-Science-Course-Khammam"
                >
                  Khammam
                </Link>
                <Link
                  title="Data Science Course in Jacksonville"
                  to="/Data-Science-Course-Jacksonville"
                >
                  Jacksonville
                </Link>
                <Link
                  title="Data Science Course in Newark"
                  to="/Data-Science-Course-Newark"
                >
                  Newark
                </Link>
                <Link
                  title="Data Science Course in Pittsburgh"
                  to="/Data-Science-Course-Pittsburgh"
                >
                  Pittsburgh
                </Link>
                <Link
                  title="Data Science Course in Raleigh"
                  to="/Data-Science-Course-Raleigh"
                >
                  Raleigh
                </Link>
                <Link
                  title="Data Science Course in Salem"
                  to="/Data-Science-Course-Salem"
                >
                  Salem
                </Link>
                <Link
                  title="Data Science Course in Sarasota"
                  to="/Data-Science-Course-Sarasota"
                >
                  Sarasota
                </Link>
                <Link
                  title="Data Science Course in Tacoma"
                  to="/Data-Science-Course-Tacoma"
                >
                  Tacoma
                </Link>
                <Link
                  title="Data Science Course in Tampa"
                  to="/Data-Science-Course-Tampa"
                >
                  Tampa
                </Link>
                <Link
                  title="Data Science Course in Abuja"
                  to="/Data-Science-Course-Abuja"
                >
                  Abuja
                </Link>
                <Link
                  title="Data Science Course in Lagos"
                  to="/Data-Science-Course-Lagos"
                >
                  Lagos
                </Link>
                <Link
                  title="Data Science Course in Manila"
                  to="/Data-Science-Course-Manila"
                >
                  Manila
                </Link>
                <Link
                  title="Data Science Course in CapeTown"
                  to="/Data-Science-Course-CapeTown"
                >
                  CapeTown
                </Link>
                <Link
                  title="Data Science Course in Calgary"
                  to="/Data-Science-Course-Calgary"
                >
                  Calgary
                </Link>
                <Link
                  title="Data Science Course in Montreal"
                  to="/Data-Science-Course-Montreal"
                >
                  Montreal
                </Link>
                <Link
                  title="Data Science Course in Vancouver"
                  to="/Data-Science-Course-Vancouver"
                >
                  Vancouver
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="faqs" className="faqnewbg py-0">
        <div className="container">
          <h2>
            <b>Frequently Asked Questions</b>
          </h2>
          <div className="faqnewbg-inner">
            <div className="faqnew">
              <div className="accordion" id="accordionExample2">
                <div className="card">
                  <div className="card-header" id="heading00">
                    <h2 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse00"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> Who should take
                        this Data Science Course of Pune ?
                      </button>
                    </h2>
                  </div>

                  <div
                    id="collapse00"
                    className="collapse"
                    aria-labelledby="heading00"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p>
                        The role of a Data Scientist demands a combination of
                        experience, knowledge in Data Science, and proficiency
                        in relevant tools and technologies. It is a promising
                        career path for both experienced and novice
                        professionals in Pune. Individuals with an analytical mindset
                        from any educational background at Pune are well-suited to
                        undertake Data Science training.
                      </p>
                      <ul>
                        <li>IT Professionals</li>
                        <li>Analytics Managers</li>
                        <li>Business Analysts</li>
                        <li>Banking and Finance Professionals</li>
                        <li>Marketing Managers</li>
                        <li>Supply Chain Network Managers</li>
                        <li>
                          Beginners or Recent Graduates in Bachelor’s or
                          Master’s Degree
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

               

                <div className="card">
                  <div className="card-header" id="heading02">
                    <h2 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse02"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> Why do you want to
                        join this course data science in Pune ?
                      </button>
                    </h2>
                  </div>

                  <div
                    id="collapse02"
                    className="collapse"
                    aria-labelledby="heading02"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p>
                        Due to the growing demand for data-driven solutions in
                        businesses, there is a significant increase in the need
                        for data scientists who possess the necessary skills in
                        Data Science. This online Data Science training program
                        will enable you to develop expertise in various areas,
                        such as Data Science, R programming language, Data
                        Analysis, and Big Data. Obtaining this certification can
                        expedite your career growth in this rapidly developing
                        field and propel it to the next level. Join our Pune Location Center.
                      </p>
                      <ul>
                        <li>
                          The average annual salary of Data Scientists as
                          per Indeed is US$15,00,000 in India.
                        </li>
                        <li>
                          Data Scientist is the best job in the 21st century
                          — Harvard Business Review
                        </li>
                        <li>
                          The number of jobs for all data professionals in the
                          India will increase to 3.4 million — IBM
                        </li>
                        <li>
                          Global Big Data market achieves US$122 billion in
                          sales in 6 years — Frost & Sullivan
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading04">
                    <h2 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse04"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i>What are the
                        educational goals of this Data Science course in Pune ?
                      </button>
                    </h2>
                  </div>

                  <div
                    id="collapse04"
                    className="collapse"
                    aria-labelledby="heading04"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p>
                      Data Science has emerged as one of the most in-demand professions this year, with the United States Bureau of Labor Statistics forecasting remarkable growth and predicting 11.5 million job opportunities by 2026, growing at an annual rate of 28% in Pune. Logicmojo Data Science course, developed in collaboration with IBM, is designed to help you master essential skills critical to the job in Pune.
                      </p>
                      <p>
                      This comprehensive Data Science course in Pune combines both live-online instructor-led classes and self-paced learning videos co-developed with IBM. Additionally, it concludes with a Capstone project that reinforces the training by allowing you to build a relevant product that encompasses all the crucial aspects learned throughout the program in Pune.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header" id="heading050">
                    <h2 className="mb-0">
                      <button
                        type="button"
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapse050"
                        aria-expanded="false"
                      >
                        <i className="fa fa-angle-down"></i> What
                        tools/technology will you learn with Data Science
                        course at Pune Location?
                      </button>
                    </h2>
                  </div>

                  <div
                    id="collapse050"
                    className="collapse"
                    aria-labelledby="heading050"
                    data-parent="#accordionExample2"
                  >
                    <div className="card-body">
                      <p>
                      A comprehensive Data Science course in Pune equips learners with various tools and technologies essential for data analysis, visualization, and modeling. Here is a list of some key tools and technologies you can expect to learn during a Data Science course in Pune:
                      </p>
                      <ul>
                        <p>
                          <b>Programming Languages</b>
                        </p>
                        <ul>
                          <li>
                            Python : Python is a versatile, open-source
                            programming language widely used in data science due
                            to its readability, extensive libraries, and large
                            community support.
                          </li>
                          <li>
                            R : R is another open-source programming language
                            specifically designed for statistical computing and
                            graphics. It is widely used for data manipulation,
                            visualization, and statistical modeling.
                          </li>
                        </ul>
                        <p>
                          <b>Data Manipulation and Analysis Libraries</b>
                        </p>
                        <ul>
                          <li>
                            Pandas (Python) : Pandas is a popular Python library
                            for data manipulation and analysis. It provides data
                            structures and functions needed to work with
                            structured data seamlessly.
                          </li>
                          <li>
                            NumPy (Python) : NumPy is a fundamental library for
                            numerical computing in Python. It provides support
                            for large, multi-dimensional arrays and matrices,
                            along with a collection of mathematical functions to
                            operate on these arrays.
                          </li>
                          <li>
                            dplyr (R) : dplyr is an R package for data
                            manipulation. It provides a set of tools for
                            efficiently transforming, summarizing, and
                            rearranging large datasets.
                          </li>
                        </ul>
                        <p>
                          <b>Data Visualization Libraries</b>
                        </p>
                        <ul>
                          <li>
                            Matplotlib (Python) : Matplotlib is a 2D plotting
                            library for Python that allows the creation of
                            various types of plots, histograms, and charts.
                          </li>
                          <li>
                            Seaborn (Python) : Seaborn is a statistical data
                            visualization library based on Matplotlib. It
                            provides a high-level interface for creating
                            visually appealing and informative statistical
                            graphics.
                          </li>
                          <li>
                            ggplot2 (R) : ggplot2 is a popular R package for
                            creating complex and professional-looking
                            visualizations using a concise syntax based on the
                            Grammar of Graphics.
                          </li>
                        </ul>
                        <p>
                          <b>Machine Learning Libraries</b>
                        </p>
                        <ul>
                          <li>
                            Scikit-learn (Python) : Scikit-learn, a prevalent
                            Python-based machine learning library, offers
                            user-friendly and effective instruments for data
                            exploration and evaluation. It accommodates an array
                            of machine learning methodologies, encompassing
                            classification, regression, and clustering
                            techniques
                          </li>
                          <li>
                            TensorFlow (Python) : TensorFlow is an open-source
                            machine learning library developed by Google. It is
                            widely used for deep learning applications, such as
                            neural networks and reinforcement learning.
                          </li>
                          <li>
                            Keras (Python) : Keras, a sophisticated neural
                            network interface penned in Python, operates
                            seamlessly atop TensorFlow, Microsoft Cognitive
                            Toolkit, Theano, or PlaidML. Boasting
                            user-friendliness, it fosters swift trials involving
                            intricate neural networks.
                          </li>
                          <li>
                            Caret (R) : Caret is an R package that streamlines
                            the process of building predictive models. It
                            provides tools for data splitting, pre-processing,
                            feature selection, model tuning, and more.
                          </li>
                        </ul>
                        <p>
                          <b>Big Data Technologies</b>
                        </p>
                        <ul>
                          <li>
                            Apache Hadoop : Apache Hadoop is an open-source
                            distributed computing framework that enables
                            processing and storage of large datasets across
                            clusters of computers using simple programming
                            models.
                          </li>
                          <li>
                            Apache Spark : Apache Spark is an open-source,
                            distributed computing system that provides a fast
                            and general-purpose cluster-computing framework for
                            big data processing.
                          </li>
                          <li>
                            NoSQL Databases : NoSQL databases, including MongoDB
                            and Cassandra, represent non-relational databases
                            devised to manage copious amounts of both structured
                            and unstructured data, ensuring scalability and
                            steadfast accessibility.
                          </li>
                          <li>
                            To sum up, a Data Science course encompasses a
                            diverse array of instruments and innovations that
                            empower learners to gather, scrutinize, depict, and
                            formulate data. Gaining proficiency in these tools
                            is crucial for aspiring data scientists as they
                            tackle intricate, real-world challenges
                          </li>
                        </ul>
                      </ul>
                    </div>
                  </div>
                </div>

                <button
                  onClick={() => setTg(!toggle)}
                  className="btn btn-primary mb-3 viewmorebtn"
                >
                  {toggle ? "View Less" : "View More"}
                </button>

                {toggle && (
                  <div className="morefaq">
                    <div className="card">
                      <div className="card-header" id="heading07">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse07"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> The average
                            annual salary of Data Science Engineer  in Pune as per Report
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse07"
                        className="collapse"
                        aria-labelledby="heading07"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In Pune, the average salary of a Data Science
                            Engineer is INR : 21,42,957.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading08">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse08"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What does the
                            responsibilities as a Data Scientist in IT for Pune Location ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse08"
                        className="collapse"
                        aria-labelledby="heading08"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>                   
                          Data Scientists in Pune hold an essential position within the IT realm by deriving significant understanding from immense data quantities, thereby bolstering informed decision-making. In this piece, we delve into the primary duties of a Data Scientist in the IT field in Pune.
                          </p>
                          <p>
                            <b>Data Collection and Pre-processing</b>
                          </p>
                          <ul>
                            <li>
                            A Data Scientist's tasks in Pune involve gathering information from diverse origins, such as databases, APIs, and web extraction. Their duty in Pune is to refine, prepare, and convert unprocessed data into organized forms apt for subsequent examination, while maintaining data precision and uniformity.
                            </li>
                          </ul>
                          <p>
                            <b>Data Exploration and Analysis</b>
                          </p>
                          <ul>
                            <li>
                              Data Scientists examine and scrutinize data to
                              detect tendencies, recurring motifs, and
                              irregularities. They employ statistical methods,
                              including descriptive statistics, inferential
                              statistics, and hypothesis evaluation, to
                              encapsulate and elucidate data. This approach aids
                              in uncovering connections and prospective
                              revelations that can steer business choices
                            </li>
                          </ul>
                          <p>
                            <b>Feature Engineering and Selection</b>
                          </p>
                          <ul>
                            <li>
                              Data Scientists examine and scrutinize data to
                              detect tendencies, recurring motifs, and
                              irregularities. They employ statistical methods,
                              including descriptive statistics, inferential
                              statistics, and hypothesis evaluation, to
                              encapsulate and elucidate data. This approach aids
                              in uncovering connections and prospective
                              revelations that can steer business choices
                            </li>
                          </ul>
                          <p>
                            <b>
                              Developing and Implementing Machine Learning
                              Models
                            </b>
                          </p>
                          <ul>
                            <li>
                              Data Scientists build, train, and evaluate machine
                              learning models to solve specific business
                              problems. They choose appropriate algorithms, such
                              as regression, classification, or clustering, and
                              fine-tune model parameters to optimize
                              performance. They also validate models using
                              techniques like cross-validation and assess their
                              accuracy, precision, recall, and other relevant
                              metrics.
                            </li>
                            <p>
                              <b>Data Visualization and Communication</b>
                            </p>
                            <li>
                              Data Scientists craft visual depictions of data
                              assessments and modeled outcomes to convey
                              intricate data efficiently. Utilizing data
                              visualization instruments and libraries, like
                              Matplotlib, Seaborn, or ggplot2, they generate
                              plots, diagrams, and visual representations that
                              simplify comprehension and guide decision-making
                            </li>
                          </ul>
                          <p>
                            <b>Collaboration with Cross-Functional Teams</b>
                          </p>
                          <ul>
                            <li>
                              Data Scientists collaborate intimately with
                              diverse teams across the organization, including
                              product managers, software engineers, and business
                              analysts. They establish project goals,
                              synchronize data-focused approaches, and guarantee
                              the triumphant execution of data-centered
                              resolutions
                            </li>
                          </ul>
                          <p>
                            <b>Staying Updated with Emerging Technologies</b>
                          </p>
                          <ul>
                            <li>
                              Data Scientists must continuously update their
                              knowledge and skills in the rapidly evolving field
                              of data science. They should stay informed about
                              new algorithms, tools, and best practices to
                              improve their workflow and contribute effectively
                              to their organization's success.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading09">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse09"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is a Flexi
                            Subscription in Data Science Foundation Program in Pune?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse09"
                        className="collapse"
                        aria-labelledby="heading09"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                          Individuals who register for live classroom training in Pune in Data Science are entitled to a Flexi Pass. This pass grants access to ongoing batch information for a duration of 2 years in Pune, enabling participants to attend live sessions from any batch and learn at their own pace. This option is particularly advantageous for those in Pune who work shifts or weekends.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading10">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse10"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            prerequisites to start a career in Data Science ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse10"
                        className="collapse"
                        aria-labelledby="heading10"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            If you are interested in learning Data Science
                            course, there are several prerequisites that you
                            should consider due to the increasing demand in this
                            field:
                          </p>
                          <ol>
                            <li>
                              Mathematical Skills: A strong foundation in
                              mathematical concepts like linear algebra,
                              matrices, calculus, gradients, etc. is a major
                              prerequisite for taking up Data Science courses.
                            </li>
                            <li>
                              Programming Skills: It is essential to have a good
                              understanding of programming languages such as
                              Python, C, C++, SQL, Java, etc. to gain complete
                              knowledge and understanding throughout the Data
                              Science online course.
                            </li>
                            <li>
                              Data Processing: As Data Science revolves around
                              handling data, it is crucial to be familiar with
                              data mining, data modeling, data processing, etc.,
                              which will help you pursue Data Science online
                              training with ease.
                            </li>
                            <li>
                              Statistical Analysis: Possessing expertise in
                              statistical analysis is a significant advantage
                              when it comes to learning Data Science. Data
                              Science aims to extract valuable insights from
                              vast collections of data, and experience working
                              with analytical tools such as Hadoop, Python, SAS,
                              and many more can help you perform statistical
                              analytics efficiently.
                            </li>
                            <li>
                              Data Visualization Skills: Familiarity with data
                              visualization tools such as Matplotlib, Tableau,
                              and others can help you comprehend complex
                              outcomes and enable your audience to understand
                              the metrics.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading11">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse11"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Why should I
                            enroll for Logicmojo Data Science Course in Pune ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse11"
                        className="collapse"
                        aria-labelledby="heading11"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo provides top-notch online Data Science
                            courses in Pune for professionals seeking to broaden their
                            knowledge and establish a career in this field.
                            There are numerous compelling reasons to select
                            Logicmojo as your preferred training provider:
                          </p>
                          <ul>
                            <li>A personal mentor to track your progress</li>
                            <li>
                              Immersive online instructor-led sessions conducted
                              by SMEs
                            </li>
                            <li>
                              Extensive LMS, allowing you to view recorded
                              sessions within 3 hours
                            </li>
                            <li>
                              Real-time exercises, assignments, and projects
                            </li>
                            <li>24/7 learning support</li>
                            <li>A large community of like-minded learners</li>
                            <li>Industry-recognized Logicmojo badge</li>
                            <li>* Personalized job support</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading12">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse12"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What knowledge
                            can be gained from this top-notch Logicmojo Data
                            Science program in Pune ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse12"
                        className="collapse"
                        aria-labelledby="heading12"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Through this Data Science training, you will master
                            the following concepts:
                          </p>
                          <ul>
                            <li>
                              Data analysis, project life cycle, and Data
                              Science in the real world.
                            </li>
                            <li>Machine Learning algorithms</li>
                            <li>
                              Techniques of evaluation, experimentation, and
                              project deployment
                            </li>
                            <li>
                              Analysis segmentation using clustering and the
                              method of prediction.
                            </li>
                            <li>Python with Data Science.</li>
                            <li>Git, Storytelling</li>
                            <li>
                              Data Science at scale with PySpark, AI with
                              TensorFlow
                            </li>
                            <li>
                              Deploying Machine Learning models on Clouds
                              (MLOps)
                            </li>
                            <li>Data visualization with Tableau</li>
                            <li>
                              Natural Language Processing and its applications
                            </li>
                            <li>
                              Microsoft Excel for data analysis and data
                              transformation
                            </li>
                            <li>
                              Data Science projects, analytics, and recommender
                              systems
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading14">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse14"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            Data Science course fees in Pune?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse14"
                        className="collapse"
                        aria-labelledby="heading14"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The Data Science training course in Pune costs Rs.
                            74,000 (inclusive of taxes), and there are no-cost
                            EMI plans available for 3, 6, 9, and 12 months. The
                            no-cost EMI option starts at Rs. 4500 per month. If
                            you are interested in this payment option, please
                            call us toll-free at +91 8088975867
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading15">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse15"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            total duration of this Data Science course in Pune ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse15"
                        className="collapse"
                        aria-labelledby="heading15"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The Data Science course spans over a period of 8
                            months and includes exclusive hackathons,
                            masterclasses, and ask-me-anything sessions by IBM.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading16">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse16"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            different paths to enter Data Science
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse16"
                        className="collapse"
                        aria-labelledby="heading16"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            We will explore the different paths to enter data
                            science.
                          </p>
                          <ol>
                            <li>
                              Online Learning: With its growing popularity in
                              recent times, online education stands as a
                              feasible gateway to data science. A plethora of
                              virtual courses and programs are available for
                              acquiring data science expertise.
                            </li>
                            <li>
                              Bootcamps: Data science bootcamps, characterized
                              by their intensive nature, equip you with the
                              essential skills for a data science career. These
                              programs span a brief period, typically lasting
                              from a few weeks to several months.
                            </li>
                            <li>
                              Formal Education: Entering data science through
                              traditional academia remains a popular choice.
                              Multiple degree options exist, including
                              bachelor's, master's, and PhD programs.
                            </li>
                            <li>
                              Bachelor's Degree: A bachelor's degree in a
                              pertinent field, such as mathematics, computer
                              science, or statistics, lays the groundwork for a
                              data science career. Students gain exposure to
                              programming languages like Python or R,
                              statistics, and data analysis methodologies.
                            </li>
                            <li>
                              Master's Degree: Pursuing a master's degree in
                              data science or a related discipline offers a
                              deeper understanding of the field. Advanced
                              techniques, including machine learning, data
                              mining, and data visualization, form the crux of
                              these programs.
                            </li>
                            <li>
                              PhD: For those with aspirations in research or
                              academia, a data science PhD equips you with the
                              required expertise and knowledge. Advanced
                              research methodologies and participation in
                              groundbreaking projects are key components of
                              these programs.
                            </li>
                            <li>
                              Self-Learning: As an alternative, self-learning
                              also paves the way for entering data science.
                              Numerous online resources, such as blogs,
                              tutorials, and videos, are available to hone data
                              science skills. Nonetheless, self-learning demands
                              discipline and motivation.
                            </li>
                            <li>
                              Certifications: Securing various certifications
                              helps showcase your data science prowess to
                              potential employers. Well-regarded certifications
                              include Certified Analytics Professional (CAP),
                              IBM Data Science Professional Certificate, and
                              Microsoft Certified: Azure Data Scientist
                              Associate.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading17">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse17"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Which
                            programming language is helpful in Data Science &
                            why?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse17"
                        className="collapse"
                        aria-labelledby="heading17"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Selecting an apt programming language for data
                            science hinges on myriad factors, such as the
                            quandary's nature, the magnitude of the data set,
                            and the data scientist's prowess. Neophytes can
                            commence with Python or R, offering a gentle
                            learning gradient and a vast array of instruments
                            for data dissection. Conversely, if the data set is
                            colossal, SQL may be the prime selection for data
                            preprocessing and purification. Should the
                            undertaking necessitate statistical scrutiny, SAS
                            could be the superior alternative.
                          </p>
                          <ul>
                            <li>
                              Python: Python is an elevated programming
                              language, prevalently employed in the realm of
                              data science. Boasting a minimalist syntax, it
                              facilitates effortless learning for novices.
                              Python offers an extensive assortment of libraries
                              and frameworks for data science, encompassing
                              NumPy, Pandas, Matplotlib, and Scikit-learn.
                              Moreover, Python finds applications in web
                              development, machine learning, and artificial
                              intelligence.
                            </li>
                            <li>
                              R: R, a statistical programming language, enjoys
                              widespread utilization in data science. It
                              proffers an expansive array of statistical and
                              graphical techniques for data dissection.
                              Additionally, R is employed for data
                              visualization, machine learning, and prognostic
                              modeling. Despite R's steeper learning incline
                              compared to Python, it remains a potent apparatus
                              for statistical analysis.
                            </li>
                            <li>
                              SQL: SQL, a domain-specific language, excels in
                              managing and manipulating relational databases. It
                              is prevalently adopted in data science for data
                              extraction, transformation, and loading.
                            </li>
                            <li>
                              SAS: SAS, a proprietary statistical software
                              suite, is employed for data administration,
                              analysis, and visualization. Industries such as
                              healthcare, finance, and marketing extensively
                              utilize SAS. Although SAS presents a steeper
                              learning curve, it offers an ample range of tools
                              for data dissection and modeling.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading18">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse18"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Which Companies
                            hire data scientist in Pune Location?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse18"
                        className="collapse"
                        aria-labelledby="heading18"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Data scientists employ an assortment of tools and
                            techniques to scrutinize vast datasets, extracting
                            insights that aid businesses in making well-informed
                            decisions. Their expertise spans machine learning,
                            data visualization, and statistical analysis, making
                            them highly sought after across numerous industries.
                          </p>
                          <ol>
                            <li>
                              <p>Google: </p>
                              <p>
                                As a global technology behemoth, Google
                                continually seeks exceptional talent in data
                                science. The firm maintains a dedicated team of
                                data scientists working on projects from
                                refining search algorithms to crafting machine
                                learning models for Google's cloud services.
                                Besides competitive remuneration and benefits,
                                Google fosters professional growth and career
                                progression.
                              </p>
                            </li>

                            <li>
                              <p>Amazon: </p>
                              <p>
                                Amazon, another technological titan, heavily
                                invests in data science. Data scientists operate
                                across diverse departments, including marketing,
                                advertising, operations, and logistics. They are
                                tasked with creating predictive models and
                                devising algorithms to optimize operations and
                                enhance customer experiences.
                              </p>
                            </li>

                            <li>
                              <p>Facebook: </p>
                              <p>
                                Facebook, one of the world's largest social
                                media platforms, possesses a treasure trove of
                                user data to refine its products and services.
                                The corporation maintains a vast team of data
                                scientists charged with analyzing data and
                                generating insights to better comprehend user
                                behavior. Facebook provides competitive
                                salaries, benefits, and opportunities for career
                                expansion.
                              </p>
                            </li>

                            <li>
                              <p>Apple: </p>
                              <p>
                                Apple, another tech giant, is deeply committed
                                to data science. Data scientists work across
                                various departments, from product development to
                                marketing and advertising. They are responsible
                                for constructing predictive models and
                                formulating algorithms to improve products and
                                services.
                              </p>
                            </li>

                            <li>
                              <p>Microsoft: </p>
                              <p>
                                Microsoft, a leading software company, employs a
                                data science team dedicated to developing an
                                array of products and services. Data scientists
                                tackle projects from creating machine learning
                                models for cloud services to enhancing the
                                precision of search engine results. Microsoft
                                proffers competitive salaries, benefits, and
                                opportunities for professional advancement.
                              </p>
                            </li>

                            <li>
                              <p>Uber: </p>
                              <p>
                                Uber, a company heavily reliant on data for
                                operational optimization, requires adept data
                                scientists. These specialists build predictive
                                models and design algorithms to better
                                understand user behavior and improve services.
                                Uber offers competitive remuneration, benefits,
                                and opportunities for career development.
                              </p>
                            </li>

                            <li>
                              <p>Netflix: </p>
                              <p>
                                Netflix has constructed its business around data
                                science. Data scientists work across
                                departments, from content creation to customer
                                experience management. They are charged with
                                analyzing user data and generating insights to
                                refine the company's content and services.
                              </p>
                            </li>

                            <li>
                              <p>LinkedIn: </p>
                              <p>
                                Specializing in professional networking,
                                LinkedIn necessitates skilled data scientists.
                                These experts analyze user data and develop
                                insights to help LinkedIn better understand its
                                users and enhance its services. The company
                                offers competitive salaries, benefits, and
                                opportunities for professional growth and
                                advancement.
                              </p>
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading19">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse19"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            different job roles that a Data Scientist can
                            pursue?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse19"
                        className="collapse"
                        aria-labelledby="heading19"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            There are numerous job opportunities available for
                            Data Scientists,like:
                          </p>
                          <ul>
                            <li>Business Analyst.</li>
                            <li>Data Analyst</li>
                            <li>Big Data Engineer</li>
                            <li>Data Scientist</li>
                            <li>Statistician</li>
                            <li>Data Engineer</li>
                            <li>Machine Learning Engineer</li>
                            <li>Data Architect</li>
                          </ul>
                          <p>
                            With the increasing demand for data science
                            professionals, many different job roles have emerged
                            in this field. In this article, we will discuss some
                            of the different job roles that a data scientist can
                            pursue.
                          </p>
                          <ul>
                            <li>
                              <p>Data Scientist: </p>
                              <p>
                                A data scientist is responsible for collecting,
                                analyzing, and interpreting large sets of data.
                                They use various tools and techniques to extract
                                useful insights from the data and present them
                                in a way that is understandable to non-technical
                                stakeholders. They work on real-world problems
                                and help organizations make data-driven
                                decisions.
                              </p>
                            </li>

                            <li>
                              <p> Machine Learning Engineer: </p>
                              <p>
                                A machine learning engineer designs and develops
                                algorithms and models that enable machines to
                                learn and make predictions from data. They work
                                closely with data scientists to create
                                predictive models that can be used to make
                                business decisions. They also optimize and
                                deploy machine learning models in production
                                environments.
                              </p>
                            </li>

                            <li>
                              <p> Data Analyst: </p>
                              <p>
                                A data analyst is responsible for collecting and
                                analyzing data, and presenting it in a way that
                                is easy to understand. They work with both
                                quantitative and qualitative data to provide
                                insights that help organizations make better
                                decisions. They also identify patterns and
                                trends in data to help organizations optimize
                                their operations.
                              </p>
                            </li>

                            <li>
                              <p> Business Intelligence Analyst: </p>
                              <p>
                                A business intelligence analyst is responsible
                                for collecting, analyzing, and presenting data
                                to help organizations make informed business
                                decisions. They work with data from a variety of
                                sources, including sales, marketing, and
                                operations, to identify trends and patterns that
                                can help drive business growth.
                              </p>
                            </li>

                            <li>
                              <p> Data Engineer: </p>
                              <p>
                                A data engineer is responsible for designing,
                                building, and maintaining the infrastructure
                                required to store and process large amounts of
                                data. They work with data scientists and other
                                data professionals to ensure that data is stored
                                and processed efficiently and accurately.
                              </p>
                            </li>

                            <li>
                              <p> Data Architect: </p>
                              <p>
                                A data architect is responsible for designing
                                and building the overall data architecture for
                                an organization. They work with data engineers
                                and other data professionals to design and
                                implement data pipelines, data storage systems,
                                and data processing frameworks that enable data
                                scientists to work efficiently.
                              </p>
                            </li>

                            <li>
                              <p> Database Administrator: </p>
                              <p>
                                A database administrator is responsible for the
                                design, implementation, and maintenance of
                                databases. They ensure that data is stored
                                securely and is easily accessible by authorized
                                personnel. They also optimize database
                                performance and troubleshoot any issues that
                                arise.
                              </p>
                            </li>

                            <li>
                              <p> Statistician: </p>
                              <p>
                                A statistician is responsible for designing
                                experiments and analyzing data to identify
                                patterns and trends. They work with data
                                scientists to help them develop statistical
                                models and algorithms that can be used to solve
                                business problems.
                              </p>
                            </li>

                            <li>
                              <p> Data Journalist: </p>
                              <p>
                                A data journalist is responsible for collecting
                                and analyzing data to create compelling stories.
                                They use data to provide insights into current
                                events and trends, and they present their
                                findings in a way that is easy to understand for
                                the general public.
                              </p>
                            </li>

                            <li>
                              <p> Quantitative Analyst: </p>
                              <p>
                                A quantitative analyst is responsible for using
                                mathematical and statistical methods to analyze
                                financial data. They work with investment banks,
                                hedge funds, and other financial institutions to
                                help them make informed investment decisions.
                              </p>
                            </li>
                          </ul>
                          <p>
                            In conclusion, there are many different job roles
                            that a data scientist can pursue. From data analysis
                            to machine learning, the demand for skilled
                            professionals in this field is rapidly increasing.
                            By pursuing one of these job roles, you can help
                            organizations make data-driven decisions and drive
                            business growth.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading20">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse20"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How long does
                            it take to become a Data Scientist
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse20"
                        className="collapse"
                        aria-labelledby="heading20"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            To become a data scientist, it's important to have a
                            solid background in math, statistics, computer
                            science, and programming. This usually means earning
                            a bachelor's degree in computer science, statistics,
                            math, or a related area. Data scientists also need
                            to have good analytical and critical thinking
                            abilities, and they should be able to explain
                            complicated ideas to people who aren't experts in
                            the field.
                          </p>
                          <p>
                            Becoming a Data Scientist can happen in a relatively
                            short time. When you finish our Data Science
                            training program, meet all the requirements, and
                            complete all the projects, you'll get a certificate
                            that's recognized by the industry. Plus, our
                            placement team is here to help you with your resume
                            and practice interviews, so you can land a
                            well-paying job as a Data Scientist.
                          </p>
                          <p>
                            Although, The journey to becoming a Data Scientist
                            fluctuates based on a person's history, antecedent
                            expertise, and educational trajectory. Within this
                            piece, we shall delve into the elements impacting
                            the time span needed to transform into a Data
                            Scientist while offering a rough approximation of
                            the requisite time commitment.
                          </p>
                          <p>
                            <b> Educational Background</b>
                          </p>
                          <ul>
                            <li>
                              A robust grounding in math, statistics, and
                              computer science proves crucial for those seeking
                              a data science career. For those possessing an
                              applicable bachelor's degree, like computer
                              science, engineering, or mathematics, the learning
                              process might be expedited compared to individuals
                              hailing from dissimilar domains.
                            </li>
                          </ul>
                          <p>
                            <b>Prior Experience</b>
                          </p>
                          <ul>
                            <li>
                              Former exposure to programming, data examination,
                              or machine learning can considerably truncate the
                              duration required to evolve into a Data Scientist.
                              Experts well-versed in these domains may merely
                              need to acquire distinct data science instruments
                              and methodologies to segue into a data science
                              position.
                            </li>
                          </ul>
                          <p>
                            <b> Learning Path</b>
                          </p>
                          <ul>
                            <li>
                              Formal Education: A master's or Ph.D. program in
                              data science, statistics, or a related field
                              typically takes 2-5 years to complete. This option
                              provides in-depth knowledge and hands-on
                              experience but requires a significant time
                              commitment.
                            </li>

                            <li>
                              Bootcamps: Data science bootcamps offer intensive,
                              short-term training programs that usually last
                              between 3 to 6 months. These programs focus on
                              practical skills and provide a faster route to
                              enter the field compared to formal education.
                            </li>

                            <li>
                              Online Courses and Self-Study: Online platforms,
                              such as Coursera, edX, and Udacity, offer data
                              science courses that can be completed at your own
                              pace. The duration of this learning path depends
                              on the time you can dedicate to studying and your
                              ability to grasp new concepts.
                            </li>
                          </ul>
                          <p>
                            <b>Skill Development and Practice</b>
                          </p>
                          <ul>
                            <li>
                              Acquiring the necessary skills for a data science
                              role, including programming languages (e.g.,
                              Python, R), data visualization, and machine
                              learning techniques, requires dedicated practice.
                              Building a portfolio of data science projects is
                              essential to showcase your skills and gain
                              practical experience. The time needed for skill
                              development and practice varies from person to
                              person.
                            </li>
                            <li>
                              Considering these factors, the time it takes to
                              become a Data Scientist can range from a few
                              months to several years. Individuals with relevant
                              educational backgrounds and prior experience may
                              require less time, while those starting from
                              scratch will need a longer period for learning and
                              skill development.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading21">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse21"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is this course
                            designed for individuals who are new to Data Science
                            or those who already have experience in the field
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse21"
                        className="collapse"
                        aria-labelledby="heading21"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Our Data Science course is crafted to accommodate
                            both newcomers to the field and seasoned
                            professionals aiming to boost their expertise in
                            this area.
                          </p>
                          <p>
                            Generally, anyone with an interest in data science
                            can find value in this course. Regardless of your
                            experience level, you have the opportunity to learn
                            new methods and broaden your skillset.
                          </p>
                          <ul>
                            <li>
                              <p> For beginners: </p>
                              <p>
                                If you're just venturing into data science, this
                                course serves as an exceptional starting point.
                                The course encompasses all the essentials of
                                data science, such as statistics, programming
                                languages like Python, data visualization, and
                                machine learning. It offers a thorough overview
                                of the field, enabling you to establish a strong
                                foundation and deepen your understanding of the
                                concepts.
                              </p>
                            </li>

                            <li>
                              <p> For Intermediate Learners: </p>
                              <p>
                                Those with some prior experience in data science
                                can also profit from this Logicmojo course. The
                                curriculum delves into more sophisticated
                                subjects like deep learning and natural language
                                processing. Additionally, hands-on experience
                                with real-world datasets helps you develop
                                practical skills that are applicable to your
                                work.
                              </p>
                            </li>

                            <li>
                              <p> For Advanced Learners: </p>
                              <p>
                                Even experienced data scientists can find
                                advantages in this course. The curriculum
                                explores advanced topics like big data
                                processing, distributed computing, and
                                cloud-based solutions. Furthermore, you'll gain
                                access to state-of-the-art tools and techniques,
                                ensuring you remain current with the latest
                                developments in the field.
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading22">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse22"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            process of getting into the placement pool ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse22"
                        className="collapse"
                        aria-labelledby="heading22"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In order to qualify for our placement pool, learners
                            must successfully complete the course, including
                            submitting all projects and assignments.
                            Additionally, they must pass the Placement Readiness
                            Test (PRT) to gain access to our job portal and
                            participate in our career mentoring sessions.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading23">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse23"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What are the
                            different modes of Courses that Logicmojo provides
                            for Data Science ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse23"
                        className="collapse"
                        aria-labelledby="heading23"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            At Logicmojo, you have the option to enroll in
                            either our instructor-led online training or our
                            self-paced training program. Additionally, we offer
                            corporate training for organizations seeking to
                            upskill their workforce. Our trainers possess over
                            12 years of relevant industry experience and have
                            worked as consultants in the same field, making them
                            experts in their subject matter. We encourage you to
                            view our sample videos to assess the quality of our
                            trainers.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading24">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse24"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can I request
                            for a support session if I need to better understand
                            the topics ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse24"
                        className="collapse"
                        aria-labelledby="heading24"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            At Logicmojo, we provide 24/7 query resolution
                            services through our dedicated support team. If you
                            have any questions, you can raise a ticket at any
                            time and receive email support. If your query
                            remains unresolved, we can arrange one-on-one
                            sessions with our support team. It's important to
                            note that this 1:1 session support is available for
                            a period of 6 months from the start date of your
                            course.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading25">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse25"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What kind of
                            projects are included as part of the training ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse25"
                        className="collapse"
                        aria-labelledby="heading25"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Within the Logicmojo training program framework, we
                            furnish participants with contemporary and pertinent
                            real-world projects, enhancing the value of their
                            educational journey. These endeavors empower you to
                            implement the knowledge and competencies acquired in
                            an authentic industry environment. Our training
                            comprises a multitude of projects, meticulously
                            examining your skills, comprehension, and hands-on
                            experience, ensuring comprehensive preparedness for
                            the professional sphere.
                          </p>
                          <p>
                            Throughout the course, you'll be afforded the
                            opportunity to tackle exhilarating projects across a
                            myriad of sectors, encompassing high technology,
                            e-commerce, marketing, sales, networking, banking,
                            insurance, and beyond. Upon the triumphant
                            conclusion of these undertakings, your expertise
                            will be tantamount to six months of intense industry
                            experience.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading26">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse26"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> You May
                            Question If Data Science Course Is Worth It?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse26"
                        className="collapse"
                        aria-labelledby="heading26"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, there are plenty of job opportunities available
                            in the field of Data Science and Analytics across
                            various industries globally. As businesses have
                            realized the significance of using historical data
                            for informed decision-making and improving their
                            operations, digitalization has enabled the
                            generation and analysis of vast amounts of data.
                            This has created numerous job openings in the data
                            science and analytics space. The demand for skilled
                            Data Scientists far exceeds the supply, resulting in
                            high salaries and being regarded as one of the
                            best-paying industries. The Data Scientist career
                            path is promising and rewarding as the amount of
                            online data generated is continually increasing in
                            the future.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading27">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse27"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Does Logicmojo
                            offer job assistance after completing data science
                            course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse27"
                        className="collapse"
                        aria-labelledby="heading27"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            At Logicmojo, we offer placement assistance to all
                            learners who have successfully completed our
                            training program in data science. We have
                            collaborated with over 80 top MNCs worldwide,
                            ensuring that our learners get the best possible
                            opportunities to work in reputed organizations such
                            as TCS, Sony, Ericsson, Cisco, Cognizant, Mu Sigma,
                            Standard Chartered, and many more. Our team also
                            provides support with job interview preparation and
                            resume building.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading28">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse28"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is doing a Data
                            Science course worth it?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse28"
                        className="collapse"
                        aria-labelledby="heading28"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Certainly! Data Science is a highly rewarding career
                            path due to the high demand for experts in this
                            field, lucrative salaries, and the significant value
                            that it adds to businesses across diverse
                            industries.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading29">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse29"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is coding
                            required to learn Data Science ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse29"
                        className="collapse"
                        aria-labelledby="heading29"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Occasionally. Although advanced coding skills are
                            not mandatory, learners should feel at ease with
                            data analytics, management, and visualization.
                          </p>
                          <p>
                            Basic knowledge of programming languages like C/C++,
                            Python, R, Java, or SQL can enhance the learning
                            process. Acquiring expertise in any of these
                            programming languages can aid in organizing
                            unstructured datasets.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading30">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse30"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What skills
                            will help during the Data Science training in Pune ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse30"
                        className="collapse"
                        aria-labelledby="heading30"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Having the following skills can be advantageous for
                            your learning process.
                          </p>
                          <ul>
                            <li>
                              Math Skills: Familiarity with concepts such as
                              linear algebra, calculus, matrices, gradients,
                              etc. can be helpful in various fields.
                            </li>
                            <li>
                              Programming Skills: Proficiency in programming
                              languages like Python, Java, SQL, C, C++, etc. can
                              help you write efficient code and automate tasks.
                            </li>
                            <li>
                              Data Processing: Knowledge of data mining, data
                              processing, and data modeling techniques can
                              assist you in analyzing and deriving insights from
                              large datasets.
                            </li>
                            <li>
                              Statistical Analysis: Expertise in analytical
                              tools such as Hadoop, SAS, R, etc. can enable you
                              to perform advanced statistical analyses.
                            </li>
                            <li>
                              Data Visualization Skills: Competence in using
                              data visualization tools like Matplotlib, Tableau,
                              and others can help you represent complex data in
                              an intuitive and understandable manner.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading32">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse32"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Who should learn
                            Data Science ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse32"
                        className="collapse"
                        aria-labelledby="heading32"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            <b>
                              Professionals Looking to Enhance Their Skillset
                            </b>
                          </p>
                          <ul>
                            <p>
                              Current experts in many fields can greatly gain
                              from studying data science. As companies depend
                              more and more on data-based knowledge to make
                              smart choices, professionals who can comprehend,
                              examine, and make sense of data become essential
                              members of their organizations. Here are a few
                              examples:
                            </p>
                            <ul>
                              <li>
                                Marketing specialists can use data science to
                                fine-tune ad campaigns, study customer habits,
                                and predict demand.
                              </li>
                              <li>
                                Finance experts can take advantage of data
                                science to uncover fraud, control risk, and
                                discover investment possibilities.
                              </li>
                              <li>
                                Healthcare workers can employ data science to
                                enhance patient attention, find patterns in
                                medical records, and create tailored treatment
                                plans.
                              </li>
                            </ul>
                            <p>
                              <b>Students and Recent Graduates</b>
                            </p>
                            <ul>
                              <li>
                                Learners and new graduates stepping into the job
                                market can boost their chances of getting hired
                                by acquiring data science abilities. As a
                                growing number of sectors acknowledge the
                                significance of data examination, a foundation
                                in data science can lead to well-paying and
                                thrilling job prospects. Students from fields
                                like math, computer science, engineering, or
                                even social sciences can discover their skills
                                easily adaptable to data science.
                              </li>
                            </ul>
                            <p>
                              <b>Career Changers</b>
                            </p>
                            <ul>
                              <li>
                                People looking for a career shift can gain from
                                studying data science too. As this area keeps
                                expanding, there's a continuous need for capable
                                data scientists in different sectors. By
                                obtaining the necessary abilities, those
                                changing careers can move into well-paid,
                                sought-after positions like data analyst, data
                                engineer, or data scientist.
                              </li>
                            </ul>
                            <p>
                              <b>Entrepreneurs and Business Owners</b>
                            </p>
                            <ul>
                              <li>
                                Startup founders and company owners can use data
                                science to get ahead in their specific markets.
                                By grasping the details of data analysis and
                                using it for well-informed choices, they can
                                improve operations, cut expenses, and spot fresh
                                chances for expansion.
                              </li>
                            </ul>
                            <p>
                              <b>Researchers and Academics</b>
                            </p>
                            <ul>
                              <li>
                                Scholars and researchers can utilize data
                                science to progress their domains by employing
                                advanced methods to examine and understand
                                intricate data sets. Data science can be used in
                                diverse research fields, such as social
                                sciences, natural sciences, and humanities, to
                                reveal previously concealed patterns and
                                insights.
                              </li>
                            </ul>
                            <p>
                              <b>Government and Non-Profit Organizations</b>
                            </p>
                            <ul>
                              <li>
                                Government bodies and non-profit organizations
                                can immensely benefit from data science by
                                utilizing data-informed insights for shaping
                                public policies and efforts. By adopting data
                                science methods, these institutions can
                                recognize patterns, shifts, and connections that
                                result in enhanced and streamlined services to
                                the public.
                              </li>
                            </ul>
                            <p>
                              <b>Enthusiasts and Hobbyists</b>
                            </p>
                            <ul>
                              <li>
                                Passionate individuals and hobbyists eager to
                                learn data science can find numerous personal
                                and professional uses for their new skills. From
                                examining sports statistics to forecasting stock
                                market movements, data science can be an
                                enjoyable and fulfilling activity for those who
                                like dealing with data and uncovering concealed
                                patterns.
                              </li>
                            </ul>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading33">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse33"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What are some
                            steps I can take to learn Data Science and become
                            proficient in it?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse33"
                        className="collapse"
                        aria-labelledby="heading33"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            <b>
                              Develop a Solid Foundation in Mathematics and
                              Statistics
                            </b>
                          </p>
                          <ul>
                            <li>
                              To become proficient in data science, you must
                              have a strong understanding of mathematics and
                              statistics. These subjects form the backbone of
                              data science and provide the tools necessary for
                              data analysis and interpretation. Focus on topics
                              such as probability, linear algebra, calculus, and
                              statistical inference to build a strong
                              foundation.
                            </li>
                          </ul>
                          <p>
                            <b>Master Programming Languages</b>
                          </p>
                          <ul>
                            <li>
                              Coding languages are crucial for handling data and
                              applying data science methods. Begin with Python
                              and R, the most popular languages in data science.
                              These languages offer strong libraries and
                              packages that assist with data handling,
                              visualization, and examination. As you improve,
                              think about learning additional languages like SQL
                              for managing databases or Scala for processing
                              large-scale data.
                            </li>
                          </ul>
                          <p>
                            <b>Acquire Data Wrangling Skills</b>
                          </p>
                          <ul>
                            <li>
                              Data wrangling, or data preprocessing, is a
                              critical step in the data science process. Raw
                              data is often messy, incomplete, or inconsistent,
                              requiring cleaning and transformation before
                              analysis. Learn to use libraries such as pandas
                              for Python and dplyr for R to manipulate data,
                              handle missing values, and transform data into a
                              suitable format for analysis.
                            </li>
                          </ul>
                          <p>
                            <b>Study Machine Learning Algorithms</b>
                          </p>
                          <ul>
                            <li>
                              Machine learning is a core component of data
                              science, enabling the development of models that
                              can learn from data and make predictions or
                              decisions. Begin by understanding the basics of
                              machine learning and the different types of
                              algorithms, such as supervised and unsupervised
                              learning. Then, delve into popular algorithms like
                              linear regression, decision trees, and clustering
                              techniques. Familiarize yourself with machine
                              learning libraries like scikit-learn for Python
                              and caret for R.
                            </li>
                          </ul>
                          <p>
                            <b>Enhance Your Data Visualization Skills</b>
                          </p>
                          <ul>
                            <li>
                              Effective data visualization helps communicate
                              complex data insights to a non-technical audience.
                              Master data visualization libraries like
                              Matplotlib and Seaborn for Python or ggplot2 for
                              R. Learn to create a variety of visualizations,
                              such as bar charts, scatter plots, and heatmaps,
                              to effectively present your findings.
                            </li>
                          </ul>
                          <p>
                            <b>Gain Domain Expertise</b>
                          </p>
                          <ul>
                            <li>
                              Data scientists often specialize in specific
                              domains or industries, such as finance,
                              healthcare, or marketing. Gaining domain expertise
                              allows you to apply data science techniques more
                              effectively and tailor your analyses to the unique
                              challenges of a particular industry. Stay
                              up-to-date on industry trends and develop a deep
                              understanding of the problems faced by businesses
                              in your chosen domain.
                            </li>
                          </ul>
                          <p>
                            <b>Learn Big Data Technologies</b>
                          </p>
                          <ul>
                            <li>
                              As the volume of data grows, data scientists need
                              to be proficient in big data technologies to
                              handle, store, and process massive datasets. Learn
                              the fundamentals of big data processing frameworks
                              like Apache Hadoop and Apache Spark. Familiarize
                              yourself with NoSQL databases such as MongoDB and
                              Cassandra for scalable data storage and retrieval.
                            </li>
                          </ul>
                          <p>
                            <b>Participate in Data Science Competitions</b>
                          </p>
                          <ul>
                            <li>
                              Contests in data science, like those on platforms
                              such as Kaggle, present worthwhile chances to
                              utilize your abilities, gain knowledge from expert
                              data scientists, and assemble a project portfolio.
                              Engaging in these contests can assist you in
                              cultivating proficiency in diverse data science
                              methods and acquaint you with practical issues.
                            </li>
                          </ul>
                          <p>
                            <b>Network with Other Data Science Professionals</b>
                          </p>
                          <ul>
                            <li>
                              Connecting with fellow data science experts can
                              offer understanding of industry tendencies, career
                              openings, and partnership opportunities. Join
                              local gatherings, conferences, and training
                              sessions to meet people who share your interests
                              and stay up-to-date with the newest advancements
                              in data science.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading34">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse34"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>How do I learn
                            Data Science online ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse34"
                        className="collapse"
                        aria-labelledby="heading34"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo provides a range of online Data Science
                            courses that you can explore, along with tutorials,
                            blogs, interview guides, and community forums to
                            support your learning.
                          </p>
                          <p>
                            These courses are designed to help working
                            professionals master Data Science while balancing
                            work commitments. The curriculum of these online
                            programs is aligned with industry requirements and
                            standards, ensuring that you gain practical
                            knowledge and skills that are relevant in the job
                            market.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading35">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse35"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Can you suggest
                            some effective learning paths for Data Science ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse35"
                        className="collapse"
                        aria-labelledby="heading35"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <ul>
                            <p>
                              <b>
                                Foundational Knowledge: Mathematics, Statistics,
                                and Programming
                              </b>
                            </p>
                            <ul>
                              <li>
                                Embarking on a journey to become a proficient
                                data scientist requires a strong foundation in
                                mathematics, statistics, and programming.
                                Develop your skills in linear algebra, calculus,
                                probability, and statistical inference to
                                provide a solid base for your data science
                                career. Simultaneously, master programming
                                languages such as Python and R, which are widely
                                used in the data science field.
                              </li>
                            </ul>
                            <p>
                              <b>Data Manipulation and Cleaning</b>
                            </p>
                            <ul>
                              <li>
                                A crucial aspect of data science is data
                                manipulation and cleaning. Raw data is often
                                messy and requires preprocessing before
                                analysis. Familiarize yourself with libraries
                                like pandas in Python and dplyr in R to
                                effectively handle, clean, and transform data
                                for subsequent analysis.
                              </li>
                            </ul>
                            <p>
                              <b>Data Visualization and Communication</b>
                            </p>
                            <ul>
                              <li>
                                An essential skill for data scientists is the
                                ability to create data visualizations and
                                effectively communicate their findings to both
                                technical and non-technical audiences. Learn to
                                use visualization libraries such as Matplotlib
                                and Seaborn in Python or ggplot2 in R to create
                                engaging and informative visual representations
                                of your data analysis.
                              </li>
                            </ul>
                            <p>
                              <b>Machine Learning Techniques</b>
                            </p>
                            <ul>
                              <li>
                                Develop your expertise in machine learning, a
                                core component of data science that enables you
                                to build models capable of learning from data
                                and making predictions. Start by understanding
                                the basics of machine learning, such as
                                supervised and unsupervised learning. Then,
                                delve into popular algorithms like linear
                                regression, decision trees, and clustering
                                techniques.
                              </li>
                            </ul>
                            <p>
                              <b>
                                Develop your expertise in machine learning, a
                                core component of data science that enables you
                                to build models capable of learning from data
                                and making predictions. Start by understanding
                                the basics of machine learning, such as
                                supervised and unsupervised learning. Then,
                                delve into popular algorithms like linear
                                regression, decision trees, and clustering
                                techniques.
                              </b>
                            </p>
                            <ul>
                              <li>
                                As a data connoisseur, delving into deep
                                learning is pivotal, entailing the construction
                                of neural architectures to emulate intricate
                                patterns within data. Familiarize yourself with
                                prominent deep learning frameworks such as
                                TensorFlow and PyTorch, mastering the art of
                                devising and honing neural networks for
                                undertakings like image discernment and natural
                                language interpretation.
                              </li>
                            </ul>
                            <p>
                              <b>Big Data Processing and Analysis</b>
                            </p>
                            <ul>
                              <li>
                                As a data connoisseur, delving into deep
                                learning is pivotal, entailing the construction
                                of neural architectures to emulate intricate
                                patterns within data. Familiarize yourself with
                                prominent deep learning frameworks such as
                                TensorFlow and PyTorch, mastering the art of
                                devising and honing neural networks for
                                undertakings like image discernment and natural
                                language interpretation.
                              </li>
                            </ul>
                            <p>
                              <b>Domain-Specific Expertise</b>
                            </p>
                            <ul>
                              <li>
                                Focusing on a particular sector or field, like
                                finance, healthcare, or marketing, can bolster
                                your data science vocation by allowing you to
                                employ your abilities more efficiently. Acquire
                                domain proficiency by keeping abreast of sector
                                developments and comprehending the distinct
                                hurdles confronted by enterprises in your
                                selected realm.
                              </li>
                            </ul>
                            <p>
                              <b>Practical Experience and Portfolio Building</b>
                            </p>
                            <ul>
                              <li>
                                Hands-on experience is vital for developing your
                                data science skills and showcasing your
                                abilities to potential employers. Participate in
                                data science competitions on platforms like
                                Kaggle or work on personal projects that involve
                                real-world data. As you complete projects,
                                compile a portfolio to demonstrate your
                                expertise and the impact of your work.
                              </li>
                            </ul>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading36">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse36"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>How can I become
                            a Data Scientist?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse36"
                        className="collapse"
                        aria-labelledby="heading36"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            To embark on the path of becoming a Data Scientist,
                            the first step is to gain knowledge about Data
                            Science and its prerequisites. Once you have a basic
                            understanding, the next step is to enroll in a
                            reputable Data Science program offered by a reliable
                            institution. However, the journey doesn't end there.
                            To excel in the field, it's essential to practice
                            regularly and stay updated with the latest
                            advancements in this technology.
                          </p>
                          <ul>
                            <p>
                              <b>Learn Essential Machine Learning Techniques</b>
                            </p>
                            <li>
                              Machine learning is a core component of data
                              science. Begin by understanding the basics of
                              supervised and unsupervised learning, and then
                              dive deeper into popular algorithms such as linear
                              regression, decision trees, and clustering
                              techniques. Practice implementing these algorithms
                              and fine-tune your models for improved
                              performance.
                            </li>
                          </ul>
                          <p>
                            <b>Explore Deep Learning and Neural Networks</b>
                          </p>
                          <ul>
                            <li>
                              Amplify your cognizance by delving into the realm
                              of deep learning and neural network architectures.
                              These methodologies empower the development of
                              models proficient in discerning intricate
                              relationships within voluminous data compilations.
                              Acquaint yourself with deep learning schemas such
                              as TensorFlow and PyTorch, and refine your skills
                              in the art of constructing and honing neural
                              networks tailored for a multitude of undertakings,
                              encompassing visual perception and linguistic
                              processing tasks.
                            </li>
                          </ul>
                          <p>
                            <b>Get Familiar with Big Data Technologies</b>
                          </p>
                          <ul>
                            <li>
                              As a data scientist, you must be proficient in big
                              data technologies to process, store, and analyze
                              massive datasets. Learn about big data processing
                              frameworks like Apache Hadoop and Apache Spark, as
                              well as NoSQL databases such as MongoDB and
                              Cassandra. Mastering these technologies will
                              prepare you to work with large-scale data in
                              real-world scenarios.
                            </li>
                          </ul>
                          <p>
                            <b>Gain Domain Expertise in Your Chosen Industry</b>
                          </p>
                          <ul>
                            <li>
                              Cultivating proficiency in a distinct sector, be
                              it finance, healthcare, or marketing, paves the
                              way for more efficacious application of your data
                              science aptitude. Garner subject matter mastery by
                              keeping abreast of sector-specific tendencies and
                              comprehending the singular hurdles confronted by
                              enterprises within your selected domain.
                            </li>
                          </ul>
                          <p>
                            <b>
                              Participate in Data Science Competitions and
                              Projects
                            </b>
                          </p>
                          <ul>
                            <li>
                              Hands-on experience is essential for honing your
                              data science skills. Participate in data science
                              competitions on platforms like Kaggle or work on
                              personal projects involving real-world data. As
                              you complete projects, document your findings and
                              create a portfolio to showcase your expertise to
                              potential employers.
                            </li>
                          </ul>
                          <p> Engage with the Data Science Community</p>
                          <ul>
                            <li>
                              Forge connections with fellow data science
                              aficionados by participating in regional
                              gatherings, symposiums, and hands-on sessions.
                              Immersing yourself in the data science milieu
                              offers indispensable perspectives on sector
                              inclinations, vocational prospects, and
                              cooperative potentialities. Remain up-to-date with
                              the field's cutting-edge advancements and draw
                              wisdom from the collective experiences of your
                              peers.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading37">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse37"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What are some
                            recommended data science courses by Logicmojo in Pune?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse37"
                        className="collapse"
                        aria-labelledby="heading37"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo has partnered with highly regarded
                            institutions to offer a range of Data Science
                            programs that cater to aspiring Data Scientists, as
                            well as professionals seeking to enhance their
                            skills in the field. Here are some recommended
                            courses that might be suitable for you:
                          </p>
                          <p>
                            If you are unsure about which course to choose,
                            don't hesitate to contact our course advisors for
                            assistance.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading38">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse38"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Do I Need To
                            Have Strong Programming Skills To Be A Data
                            Scientist?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse38"
                        className="collapse"
                        aria-labelledby="heading38"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            To answer the question of whether programming skills
                            are required for a data science course, the answer
                            is both yes and no. Yes, because some level of
                            programming skills is necessary. However, it is not
                            required to have extremely strong programming
                            skills. At Logicmojo, we ensure that our students
                            get ample exposure to the statistical programming
                            tool called ‘Logicmojo’. We start from the basics
                            assuming that you have no prior exposure to
                            programming.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading39">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse39"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Why Should We
                            Learn Python ? Can’t We Learn Any Other Tool For
                            Data Science Course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse39"
                        className="collapse"
                        aria-labelledby="heading39"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Python is a highly attractive option in the
                            analytics space, as it has around 95% market share
                            and is open source, meaning it is free to use. Many
                            job postings require experience and exposure to
                            Python, making it a valuable skill to have. On the
                            other hand, demand for other statistical tools is
                            decreasing. Therefore, it is wise to look towards
                            the future and invest time in learning Python.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading40">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse40"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What If I Miss A
                            Live Session Classes for Data Science?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse40"
                        className="collapse"
                        aria-labelledby="heading40"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            If you happen to miss a live session for any reason
                            during your Data Science training, it won't be an
                            issue. All sessions are recorded, and you will have
                            access to them through Logicmojo’s advanced Learning
                            Management System (LMS). This allows you to watch
                            the recorded sessions at your own pace and
                            convenience, ensuring that you don't miss any
                            important material.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading41">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse41"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Will I Get A
                            Data Science Course Completion Certification From
                            Logicmojo?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse41"
                        className="collapse"
                        aria-labelledby="heading41"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes ! Upon the successful completion of the course,
                            you will receive a course completion certificate
                            from Logicmojo.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading42">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse42"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What If I Forget
                            The Data Science Concepts After Completing the
                            Course in Pune?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse42"
                        className="collapse"
                        aria-labelledby="heading42"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            We recognize that the human brain has limitations
                            when it comes to learning capacity. For this reason,
                            we record all our sessions and grant trainees
                            lifelong access to the e-learning materials.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading43">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse43"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What If I Have
                            No Experience In Data Science?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse43"
                        className="collapse"
                        aria-labelledby="heading43"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The field of Data Science has only gained global
                            attention in the past two years. As a result, many
                            companies are finding it challenging to fill the gap
                            between supply and demand for skilled professionals
                            in this area. Individuals who possess training and
                            adequate exposure to data science techniques are
                            often quickly recruited by companies
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading44">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse44"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What Is The
                            Difference Between Business Analytics, Data
                            Analytics And Data Scientist?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse44"
                        className="collapse"
                        aria-labelledby="heading44"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Data Analytics, Business Analytics, and Data Science
                            are essentially three terms that refer to the same
                            field. The professionals working in this domain are
                            commonly known as Data Scientists.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading45">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse45"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            placement rate for this data science course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse45"
                        className="collapse"
                        aria-labelledby="heading45"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo data science course can help in placement
                            in several ways. First and foremost, it provides you
                            with the necessary skills and knowledge required to
                            perform data analysis, data modeling, and data
                            visualization, which are in high demand across
                            various industries.
                          </p>
                          <p>
                            In addition, Logicmojo data science courses often
                            offer practical training that helps you gain
                            hands-on experience and build a portfolio of
                            real-world projects, which can make you more
                            attractive to potential employers and refer in
                            product companies
                          </p>
                          <p>
                            Moreover, Logicmojo have industry partnerships,
                            which can give you access to job fairs, internships,
                            or even direct job placement.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading46">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse46"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            companies recruit from this data science course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse46"
                        className="collapse"
                        aria-labelledby="heading46"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Large technology companies, such as Google,
                            Microsoft, Amazon, and Facebook, often recruit data
                            science graduates & working professional.
                            Additionally, financial institutions, such as banks
                            and insurance companies, frequently hire data
                            scientists to help them analyze customer data and
                            make better business decisions.
                          </p>
                          <p>
                            Many other industries, such as healthcare, retail,
                            and transportation, are also recognizing the
                            importance of data science and are hiring
                            professionals with these skills. Startups and
                            smaller companies also looking for data science
                            talent to help them build and scale their
                            businesses.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading47">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse47"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            average salary package offered to candidates after
                            completing this data science course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse47"
                        className="collapse"
                        aria-labelledby="heading47"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The typical annual salary for a data scientist is
                            around Rs. 1698,412. However, those who are new to
                            the field and have less than a year of experience
                            can expect to earn about Rs. 1500,000 per year. On
                            the other hand, data scientists who have been in the
                            field for 1 to 4 years may earn approximately Rs.
                            2210,811 per year.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading48">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse48"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are there any
                            prerequisites required for placement after
                            completing this data science course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse48"
                        className="collapse"
                        aria-labelledby="heading48"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Prerequisites for Placement After Completing a Data
                            Science Course
                          </p>
                          <ol>
                            <li>
                              Strong foundation in mathematics and statistics: A
                              solid understanding of mathematical concepts,
                              including linear algebra, calculus, and
                              probability, is crucial for working with data.
                              Additionally, proficiency in statistical methods,
                              such as hypothesis testing and regression
                              analysis, is essential for interpreting data and
                              drawing conclusions.
                            </li>
                            <li>
                              Programming skills: Data scientists need to be
                              proficient in at least one programming language,
                              typically Python or R, to manipulate data, create
                              visualizations, and develop machine learning
                              models.
                            </li>
                            <li>
                              Domain expertise: Depending on the industry you're
                              targeting, having knowledge of the specific domain
                              can give you a competitive edge. For example, a
                              background in finance will be advantageous for
                              data scientists working in the financial sector.
                            </li>
                            <li>
                              Communication and presentation skills: Data
                              scientists must effectively communicate their
                              findings to non-technical stakeholders. Hence,
                              strong presentation skills and the ability to
                              simplify complex concepts are vital.
                            </li>
                            <li>
                              Portfolio of projects: Showcasing your work
                              through a portfolio of projects is an excellent
                              way to demonstrate your skills and expertise to
                              potential employers. It also serves as evidence of
                              your hands-on experience in tackling real-world
                              data challenges.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading49">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse49"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is there any
                            assistance provided by Logicmojo for resume building
                            and interview preparation for placement?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse49"
                        className="collapse"
                        aria-labelledby="heading49"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes , After the completion of the data science
                            course of 8 months. Candidate is ready for
                            interviews so first we conduct resume preparation
                            session 1 to 1 followed by mock interviews.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading50">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse50"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How long does
                            it take for students to get placed after completing
                            this data science course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse50"
                        className="collapse"
                        aria-labelledby="heading50"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Several factors influence the time it takes for
                            students to get placed after completing a data
                            science course. These include:
                          </p>
                          <ol>
                            <li>
                              Skill Set and Expertise: The skills and expertise
                              students acquire during the course determine their
                              employability. A strong foundation in mathematics,
                              statistics, programming, machine learning, and
                              domain knowledge is essential for a successful
                              career in data science.
                            </li>
                            <li>
                              Portfolio of Projects: Employers look for
                              candidates who can demonstrate their skills
                              through real-world projects. Building a portfolio
                              of projects during the course can showcase your
                              expertise and increase your chances of getting
                              hired.
                            </li>
                            <li>
                              Internships and Work Experience: Internships and
                              prior work experience in data science or related
                              fields can give students a competitive edge in the
                              job market. These experiences help students apply
                              their skills in practical scenarios and make them
                              more attractive to potential employers.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading51">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse51"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are there any
                            networking opportunities provided by the course
                            provider to connect with potential employers?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse51"
                        className="collapse"
                        aria-labelledby="heading51"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, the Logicmojo offer networking opportunities to
                            connect students with potential employers. You can
                            connect alumni networks. The aim is to provide
                            students with avenues to network and build
                            connections that could help them in their job
                            search.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading52">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse52"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            role of the Logicmojo in ensuring the placement of
                            its students?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse52"
                        className="collapse"
                        aria-labelledby="heading52"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo ensure the placement of its students is to
                            offer a comprehensive education and training program
                            that equips students with the necessary skills and
                            knowledge required for the industry. Additionally,
                            the course provider may provide job placement
                            assistance, such as resume building sessions, mock
                            interviews, and networking opportunities
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading53">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse53"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can students
                            pursue internships or part-time jobs during the
                            course to enhance their chances of placement?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse53"
                        className="collapse"
                        aria-labelledby="heading53"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, Internships are useful for placements for
                            students in Data Science Field.
                          </p>
                          <p>
                            Logicmojo data science course helps students
                            internships/pre placements
                          </p>
                          <ul>
                            <li>
                              Data Science Internships improve your employment
                              prospects in Data Science Field, pay you a real
                              wage, improve your network connections, and show
                              you how a professional workplace operates.
                            </li>
                            <li>
                              Logicmojo provides you with industry experience
                              and exposure for making a carrier in Data Science.
                              Theoretical knowledge is not alone sufficient.
                              Hands on experience adds on to your resume.
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading54">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse54"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are there any
                            additional certification programs offered along with
                            the data science course that can help with placement
                            opportunities?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse54"
                        className="collapse"
                        aria-labelledby="heading54"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, Along with Data Science course completion
                            certification, Logicmojo also provide project
                            certification after completion of projects in the
                            field of Data Science related areas such as machine
                            learning, data visualization, or big data
                            technologies. These additional certifications can be
                            valuable in demonstrating specialized skills to
                            potential employers and increasing placement
                            opportunities
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading55">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse55"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What is the
                            duration of the placement support provided by
                            Logicmojo after completing the data science course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse55"
                        className="collapse"
                        aria-labelledby="heading55"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo course duration is 7-8 months, followed by
                            a placement process for the next 6 months until all
                            students are successfully placed in suitable
                            positions. This provides ample time for students to
                            learn and develop their skills, while also ensuring
                            that they have access to placement opportunities.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading56">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse56"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Are there any
                            alumni of this data science course who have
                            successfully been placed in reputed companies?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse56"
                        className="collapse"
                        aria-labelledby="heading56"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Logicmojo provide you with this information or
                            connect you with alumni who can share their
                            experiences and insights about data science
                            preparation. Additionally, you can also research
                            online or through social media platforms to find out
                            about the career trajectories of alumni from the
                            course.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading57">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse57"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What kind of
                            roles and designations can students expect after
                            completing this data science course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse57"
                        className="collapse"
                        aria-labelledby="heading57"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The roles and designations that students can expect
                            after completing Logicmojo data science course may
                            vary depending on the specific program, the skills
                            and knowledge gained during the program, and the job
                            market demand. Generally, Our data science courses
                            equip students with skills in areas such as
                          </p>
                          <ul>
                            <li>Data Scientist</li>
                            <li>Data Analysis</li>
                            <li>Machine Learning Engineer</li>
                            <li>Data Engineer</li>
                            <li>Software Developer</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading58">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse58"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>What is the
                            success rate of students getting placed in their
                            preferred companies and domains after completing
                            Logicmojo data science course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse58"
                        className="collapse"
                        aria-labelledby="heading58"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The Logicmojo Data Science Course boasts an
                            impressive success rate, with a large percentage of
                            graduates securing positions in their preferred
                            companies and domains. Key factors contributing to
                            this success include:
                          </p>
                          <ol>
                            <li>
                              Industry-Relevant Curriculum: The course content
                              is designed to align with current industry
                              demands, ensuring students acquire the skills and
                              knowledge required by top employers.
                            </li>
                            <li>
                              Strong Network of Partner Companies: Logicmojo has
                              established partnerships with numerous reputed
                              companies, increasing the likelihood of successful
                              placements for their graduates.
                            </li>
                            <li>
                              Dedicated Career Services: The career support
                              offered by Logicmojo helps students navigate the
                              job market, preparing them for interviews and
                              connecting them with potential employers.
                            </li>
                            <li>
                              Alumni Network: Graduates of the Logicmojo Data
                              Science Course become part of an extensive alumni
                              network, fostering valuable connections and
                              facilitating professional growth.
                            </li>
                          </ol>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading59">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse59"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Are there any
                            placement-related policies or agreements that
                            students should be aware of before enrolling in the
                            data science course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse59"
                        className="collapse"
                        aria-labelledby="heading59"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            No, We dont have any scheme such as Pay After
                            Placement for Data Science Course. After enrollment
                            of one time payment, there Data science curriculum
                            will start. After course completion placement
                            process will start.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading60">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse60"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i>Until when will
                            the Logicmojo students get the facility of
                            mentorship ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse60"
                        className="collapse"
                        aria-labelledby="heading60"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Depending on their specialization, our mentors will
                            provide data science training to the students until
                            they complete the course. After finishing the
                            course, students can connect with specialized
                            mentors for support with projects and job placement.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading61">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse61"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can a student
                            choose to study from their desired mentor ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse61"
                        className="collapse"
                        aria-labelledby="heading61"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            At Logicmojo, each batch of students is assigned a
                            dedicated mentor. However, if a student is not
                            satisfied with their mentor's teaching approach,
                            they can escalate the issue to the management. The
                            institution will work to address the concern and
                            provide alternative mentorship options for the
                            student.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading62">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse62"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            experience level of the mentors teaching the data
                            science course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse62"
                        className="collapse"
                        aria-labelledby="heading62"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The educator guiding the data science program boasts
                            copious expertise in the discipline, accumulating
                            over five years as a data savant for a variety of
                            leading product-centric corporations. Through this
                            odyssey, the instructor has garnered hands-on acumen
                            and dexterity in realms such as data examination,
                            computational learning, and statistical approaches.
                            Beyond their trade experience, the tutor holds
                            pertinent pedagogical exposure in the data science
                            ambit, equipping them to adeptly impart intricate
                            notions and offer insightful mentorship to learners.
                            In essence, the instructor's rich background and
                            proficiency render them an ideal choice to helm the
                            data science curriculum and facilitate students'
                            edification.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading63">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse63"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How many
                            mentors will be assigned to each student during the
                            course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse63"
                        className="collapse"
                        aria-labelledby="heading63"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            We can assign one dedicated instructor for data
                            Science to the batch, and if needed, we can schedule
                            multiple trainers based on the requirements. This
                            ensures that students receive appropriate attention
                            and support. Our priority is to provide high-quality
                            Data science training with effective teaching
                            methods. We are flexible and will adapt to the needs
                            of the students and the program. Please let us know
                            over slack if you have any specific requirements or
                            preferences.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading64">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse64"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            support can students expect from their mentors
                            during the course?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse64"
                        className="collapse"
                        aria-labelledby="heading64"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In addition to regular live classes in the course,
                            our tutors provide support to students with all
                            their data science queries over a Slack channel
                            anytime. We understand that doubts can arise anytime
                            and we want to ensure that our students receive
                            timely support. We also schedule separate live doubt
                            sessions during weekdays after office hours to cater
                            to the needs of working professionals. Our goal is
                            to help our students succeed in their data science
                            journey.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading65">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse65"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are the mentors
                            available for one-on-one sessions outside of the
                            regular class schedule ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse65"
                        className="collapse"
                        aria-labelledby="heading65"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Yes, our mentors are available for one-on-one
                            sessions outside of the regular data science class
                            schedule. We understand that some students may have
                            specific questions or may require additional
                            support, and we want to ensure that they receive the
                            attention they need. Students can schedule
                            one-on-one sessions with their mentor at a
                            convenient time for both parties. Our mentors are
                            committed to helping students succeed and will work
                            with them to address any concerns or questions they
                            may have.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading66">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse66"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Will students
                            have access to the mentors even after completing the
                            course for data science queries ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse66"
                        className="collapse"
                        aria-labelledby="heading66"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Our data science course runs for a duration of 8
                            months, and even after its completion, our mentors
                            remain available to the students for any assistance
                            they may require. Our mentors can be reached through
                            the communication platform Slack, where students can
                            message them directly. In case of urgent queries or
                            concerns, our mentors are always just a ping away on
                            Slack. Additionally, if students prefer to
                            communicate over a call, they can schedule a call
                            with their respective trainers. We understand the
                            importance of ongoing support, and our mentors are
                            always ready to provide it to our student
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading67">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse67"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is the
                            class size of the data science course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse67"
                        className="collapse"
                        aria-labelledby="heading67"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Our data science course has varying class sizes from
                            batch to batch, depending on the number of enrolled
                            students. However, our primary target audience for
                            this course is working professionals. We recognize
                            the busy schedules of our students and offer
                            flexible learning options to accommodate their
                            needs. Our goal is to provide high-quality training
                            that is relevant to the industry and helps our
                            students advance in their careers.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading68">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse68"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How often are
                            the classes held for the data science course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse68"
                        className="collapse"
                        aria-labelledby="heading68"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            We offer both weekend and weekday courses depending
                            on the availability of our students. Our weekend
                            courses are of a duration of 180 minutes, while our
                            weekday courses run for 120 minutes
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading69">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse69"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Are the Data
                            Science classes conducted online or in-person
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse69"
                        className="collapse"
                        aria-labelledby="heading69"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Web-based curriculums present a multitude of
                            benefits compared to conventional in-person classes.
                            They offer adaptability and can be accessed from any
                            location, whenever desired. Frequently, these
                            courses adopt a self-directed learning approach,
                            empowering you to absorb material at a comfortable
                            pace. Moreover, online classes typically incur lower
                            expenses than traditional in-person courses, making
                            them available to a wider array of individuals.
                          </p>
                          <p>
                            Enrolling in a comprehensive online Data Science
                            program that encompasses vital concepts within its
                            study trajectory is a stellar method to acquire
                            proficiency in the domain. This approach affords a
                            pliable and budget-friendly avenue for learning and
                            imparts a profound grasp of the core notions and
                            abilities requisite for success as a Data Scientist.
                            Additionally, you can obtain recordings of all live
                            sessions for future reference and practice.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading70">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse70"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Can students
                            interact with their peers and collaborate on
                            projects during the data science course
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse70"
                        className="collapse"
                        aria-labelledby="heading70"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Embracing the notion that education flourishes
                            through collaboration, we inspire our pupils to
                            engage with one another and jointly tackle
                            assignments within the data science curriculum.
                            Numerous avenues for connection, both within and
                            beyond the scholastic environment, are available to
                            students.
                          </p>
                          <p>
                            During instructional periods, we orchestrate group
                            dialogues and exercises, stimulating learners to
                            exchange thoughts and cooperatively address
                            challenges. We contend that this immersive
                            educational experience fosters a more profound grasp
                            of the subject matter while cultivating critical
                            thinking and problem-solving aptitudes.
                          </p>
                          <p>
                            Beyond the classroom, we supply our students with
                            access to a Slack community for peer-to-peer
                            education and collective study sessions. This
                            virtual forum enables learners to liaise with
                            classmates, exchange insights and resources, and
                            work together on data science endeavors. Our
                            experience indicates that such cooperative learning
                            methods significantly aid students in enhancing
                            their abilities and attaining a more comprehensive
                            understanding of the course content.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading71">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse71"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            feedback system is in place for students to provide
                            feedback on the mentors and the course curriculum ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse71"
                        className="collapse"
                        aria-labelledby="heading71"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            Within our esteemed establishment, we highly regard
                            the perspectives and encounters of our scholars,
                            believing that their input is crucial for delivering
                            an unparalleled educational journey. Consequently,
                            we've instituted an all-encompassing appraisal
                            mechanism, empowering students to express their
                            viewpoints on the course syllabus and their
                            preceptors.
                          </p>
                          <p>
                            This system is fashioned to be effortless and
                            approachable, with evaluations occurring after every
                            quartet of lessons within our data science cohort.
                            Throughout these sessions, learners are emboldened
                            to offer insights on myriad facets of the program,
                            encompassing the curriculum, pedagogical techniques,
                            and the efficacy of their mentors.
                          </p>
                          <p>
                            To further streamline the feedback procedure, we've
                            devised a Google form for students to complete at
                            their leisure. This user-friendly questionnaire
                            poses inquiries that permit learners to divulge
                            extensive observations about their encounters.
                            Subsequently, our faculty scrutinizes the feedback,
                            refining the syllabus and instructional
                            methodologies for forthcoming groups.
                          </p>
                          <p>
                            Ultimately, our unwavering dedication to furnishing
                            our scholars with an exceptional educational
                            experience is evident, and our appraisal system
                            exemplifies one of the numerous ways we're striving
                            toward that objective. By heeding our students and
                            enacting modifications rooted in their suggestions,
                            we're able to cultivate a learning atmosphere that
                            is enthralling, efficacious, and fulfilling.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header" id="heading007">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse007"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What kind of
                            support we will get in Data Science Course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse007"
                        className="collapse"
                        aria-labelledby="heading007"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In our Data Science Course, you can receive various
                            forms of support such as access to course materials,
                            live online classes, discussion forums, peer-to-peer
                            learning, and personalized feedback from trainers.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading017">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse017"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> How can I
                            access the course materials of Data Science?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse017"
                        className="collapse"
                        aria-labelledby="heading017"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            The course provider will share all course materials,
                            class recordings, and assignments in the Slack
                            channel. These materials will be available for
                            download to all members. This ensures easy access to
                            the course content and flexibility in learning.
                            Students can refer to the materials at their
                            convenience and pace. The Slack channel serves as a
                            centralized platform for course-related
                            communication and resource sharing.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading027">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse027"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> What is a Flexi
                            Subscription in Data Science Foundation Program?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse027"
                        className="collapse"
                        aria-labelledby="heading027"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            In case of emergencies such as medical issues, work
                            pressure, or on-site opportunities, users can switch
                            to another batch of Data Science. This will stop
                            their current batch and allow them to join another
                            batch at a later time. The course provider
                            understands the need for flexibility and
                            accommodates such situations. Students can resume
                            their learning journey when they are ready without
                            any penalty. The option to switch batches allows for
                            seamless continuation of the course.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="card">
                      <div className="card-header" id="heading037">
                        <h2 className="mb-0">
                          <button
                            type="button"
                            className="btn btn-link collapsed"
                            data-toggle="collapse"
                            data-target="#collapse037"
                            aria-expanded="false"
                          >
                            <i className="fa fa-angle-down"></i> Is there a
                            discussion forum for the course ?
                          </button>
                        </h2>
                      </div>

                      <div
                        id="collapse037"
                        className="collapse"
                        aria-labelledby="heading037"
                        data-parent="#accordionExample2"
                      >
                        <div className="card-body">
                          <p>
                            We used Slack channel for communication, users can
                            interact over the Slack community to connect with
                            all their peers for any queries.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="supportbgnew">
        <div className="container">
          <h2>24/7 Learner’s Support</h2>
          <div className="supportbgnew-inner">
            <div className="supportbgnew-inner-img">
              <img src="assets/images/supportimg.png" alt="" />
            </div>
            <div className="supportbgnew-inner-content">
              <h4>Got more questions?</h4>
              <h2>Talk to our team directly</h2>
              <p>
                Reach us and a learning consultant will get in touch with you
                shortly
              </p>
              <a href="">
                <i className="fa fa-whatsapp"></i> Enquire now
              </a>
              <a href="" style={{ background: "#1a64c0" }}>
                <i className="fa fa-whatsapp"></i> +91 80889-75867
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footerai">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-3">
              <p>
                <img src="assets/images/logo.png" alt="" />
              </p>
              <p>
                Enrol Now For Data Science Courses, System Designing Or Full
                Stack Development Courses. Master The Most Demanding Skills Of
                Job Market And Experience And Ever Growing And Lucrative Career
                Transformation.
              </p>
              <p>
                <a href="mailto:info@logicmojo.com">
                  <i className="fa fa-envelope-o"></i> info@logicmojo.com
                </a>
              </p>
              <p>
                <a href="tel:+91 80889-75867">
                  <i className="fa fa-phone"></i> +91 80889-75867
                </a>
              </p>
            </div>
            {
              <div className="col-md-6 col-lg-4">
                <h3>Courses</h3>
                <p>
                  <Link to="/Introduction-to-Data-Analytics">
                    Advance Data Science & AI Program
                  </Link>
                </p>
                <p>
                  <Link to="/Advance-Data-Science-ML-Program">
                    Advance AI & ML Program
                  </Link>
                </p>
                <p>
                  <Link to="/Master-data-Science-ai-program">
                    Master Degree Program For Data Science & AI
                  </Link>
                </p>
                <p>
                  <Link to="/AI-Fundamental-for-Non-Data-Scientist">
                    AI Fundamental for Non Data Scientist
                  </Link>
                </p>
                <p>
                  <Link to="/Data-Science-Course-For-Managers">
                    Data Science Course For Managers
                  </Link>
                </p>
                <p>
                  <Link to="/Post-Graduate-Program-For-Data-Science">
                    Post Graduate Program For Data Science
                  </Link>
                </p>
                <p>
                  <Link to="/Basics-Introduction-to-Data-Science">
                    Basic Introduction to Data Science
                  </Link>
                </p>
                <p>
                  <Link to="/Introduction-to-Data-Analytics">
                    Introduction to Data Analytics
                  </Link>
                </p>
                <p>
                  <Link to="/Applied-Data-Science-with-Python">
                    Applied Data Science with Python
                  </Link>
                </p>
              </div>
            }
            <div className="col-md-6 col-lg-2">
              <h3>Logicmojo</h3>
              <p>
                <a href="https://logicmojo.com/about_us">About Us</a>
              </p>

              <p>
                <a href="https://logicmojo.com/blog">Blogs</a>
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Terms</h3>
              <p>
                <a href="https://logicmojo.com/terms_condition">
                  Terms and Conditions
                </a>
              </p>
              <p>
                <a href="https://logicmojo.com/refund_policy">
                  Refund/Cancellation policy
                </a>
              </p>
              <p>
                <a href="https://logicmojo.com/privacy_policy">
                  Privacy Policy
                </a>
              </p>
            </div>
          </div>

          <hr />

          <div className="row">
            <div className="col-md-12 col-lg-12">
              <h3>Project Innovation Lab Address</h3>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Pune</h3>
              <p>
                Sky Loft Group Floor, Creaticity Mall, Opposite Golf Course,
                Airport Rd, Shastrinagar, Yerawada, Pune, Maharashtra 411006
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Mumbai</h3>
              <p>
                Business Centre, 3rd Floor, vinkat House, Dinshaw Vacha Road,
                Churchgate, Mumbai, Maharashtra 400020
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Delhi</h3>
              <p>
                Business Centre Park, Arunachal Building, 8th Floor, Barakhamba
                Road, New Delhi 110001
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3>Kolkata</h3>
              <p>
                Ambuja Neotia EcoCentre 5th Floor, EM-4,EM-Block, Sector 6
                Kolkata 700091
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3 className="mt-3">Hyderabad</h3>
              <p>
                NSL Centrum, Road No 1, Lane, Opp. Forum Mall Central Hub, KPHB
                4th Phase, Hyderabad, Telangana 500072
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3 className="mt-3">Bangalore</h3>
              <p>
                #23, Above Veena Mobiles, 14th Main Road, Opp-White House,
                Sector 2, Hsr Layout, Bangalore 560102
              </p>
            </div>
            <div className="col-md-6 col-lg-3">
              <h3 className="mt-3">Chennai</h3>
              <p>
                Cessanana Business Centre, Phone Booth, 3rd Floor, 39/12 Haddows
                Road, Nungambakkam, Chennai 600 006
              </p>
            </div>
          </div>

          <hr />

          <div className="row">
            {/* <div className='col-md-6 col-lg-3'>
                <h3>Bangalore</h3>
                <p><a href="#">Data Science Course Training In Bangalore</a></p>
                <p><a href="#">Machine Learning Course Training In Bangalore</a></p>
                <p><a href="#">Data Analytics Course Training In Bangalore</a></p>
                <p><a href="#">Business Analytics Course Training In Bangalore</a></p>
                <p><a href="#">Artificial Intelligence AI Course Training Bangalore</a></p>
                <p><a href="#">Full-Stack Software Developer Course In Bangalore</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Hyderabad</h3>
                <p><Link to="/Data-Science-Course-Hydrabad">Data Science Course Training In Hyderabad</Link></p>
                <p><a href="#">Machine Learning Course Training In Hyderabad</a></p>
                <p><a href="#">Data Analytics Course Training In Hyderabad</a></p>
                <p><a href="#">Business Analytics Course Training In Hyderabad</a></p>
                <p><a href="#">Artificial Intelligence AI Course Training Hyderabad</a></p>
                <p><a href="#">Full-Stack Software Developer Course In Hyderabad</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Dubai</h3>
                <p><a href="#">Data Science Course Training In Dubai</a></p>
                <p><a href="#">Machine Learning Course Training In Dubai</a></p>
                <p><a href="#">Data Analytics Course Training In Dubai</a></p>
                <p><a href="#">Business Analytics Course Training In Dubai</a></p>
                <p><a href="#">Artificial Intelligence AI Course Training Dubai</a></p>
                <p><a href="#">Full-Stack Software Developer Course In Dubai</a></p>
            </div>
            <div className='col-md-6 col-lg-3'>
                <h3>Delhi</h3>
                <p><a href="#">Data Science Course Training In Delhi</a></p>
                <p><a href="#">Machine Learning Course Training In Delhi</a></p>
                <p><a href="#">Data Analytics Course Training In Delhi</a></p>
                <p><a href="#">Business Analytics Course Training In Delhi</a></p>
                <p><a href="#">Artificial Intelligence AI Course Training Delhi</a></p>
                <p><a href="#">Full-Stack Software Developer Course In Delhi</a></p>
            </div> */}
          </div>

          <hr />

          <div className="row">
            <div className="col-lg-12">
              <p className="m-0">© 2023 LOGICMOJO. ALL RIGHTS RESERVED</p>
            </div>
          </div>
        </div>
      </div>
      <div className="modal" id="welcomepopup">
        <div className="modal-header">
          <p>
            <span className="yallowbox">
              Data Science & AI Live Classes{" "}
            </span>
          </p>
          <button type="button" className="close" data-dismiss="modal">
            ×
          </button>
        </div>  
        <div className="modal-body">
          <p>
            Data Science, Machine Learning &amp; AI Course
            <br />
            <b>
              <p style={{ textDecoration: "underline", color: "#007bff" }}>
                (Duration: 8 months)
              </p>
            </b>
          </p>
        
         
          <div className="modal-body">
            <p>Weekend Batch : 9 AM - 12 PM (IST)</p>
          </div>

          <div className="modal-footer">
            <a
              target="_default"
              href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
              className="btn btn-primary"
            >
              <b>Apply Now</b>
            </a>
          </div>
        </div>
      </div>
      <div class="footerstrip-formob"> 
        <a href="https://api.whatsapp.com/send?phone=+918088975867&amp;text=Hi%20Logicmojo">
          Chat with us{" "}
          <img
            src="https://download.cnet.com/a/img/resize/c1337f10fcaf26f6843e014f4f63e6b88c02af83/catalog/2016/05/11/93d7eae4-8cab-4e76-b4e4-dd932d302bf3/imgingest-8323235902858999630.png?auto=webp&amp;fit=crop&amp;width=64"
            width="30"
          />
        </a>{" "}
        |{" "}
        <a
          target="_default"
          href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
        >
          Call Back{" "}
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_iRdNR098BeHs9symwbCwLZ3YJCYDfVeqjQ&amp;usqp=CAU"
            width="30"
          />
        </a>
      </div>
      <div class="footerstrip">
        <a
          target="_default"
          href="https://calendly.com/logicmojo/schedule-call-back-from-experts-for-live-classes?month=2023-06"
        >
          <span>
            <i class="fa fa-hand-o-right" aria-hidden="true"></i>{" "}
            <b>
              <u>+91 8088975867</u>
            </b>
          </span>
          <span>
            <i class="fa fa-volume-control-phone" aria-hidden="true"></i>{" "}
            <b>Talk To Our Tech Team</b>{" "}
          </span>
          <span>
            <i class="fa fa-question-circle" aria-hidden="true"></i> Any query
            related to live classes
          </span>
        </a>
      </div>
    </div>
  );
}

export default DataScienceCoursePune;
